export default {
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    none: 'None',
    weekdayShort: {
      sun: 'Sun',
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat'
    },
    logout: 'Logout',
    messages: 'Messages',
    download: 'Download',
    downloadStatus: {
      downloading: 'Downloading file',
      complete: 'Download complete'
    },
    print: 'Print',
    year: 'Year',
    pdf: 'PDF',
    excel: 'Excel',
    noData: 'No data',
    noDataFound: 'No data found',
    searchGuide: 'Please search to view data',
    listLoadCount: 'Loaded {{loaded}} / {{total}} items',
    endOfList: 'End of list',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    searching: 'Searching...',
    enterSearchTerm: 'Please enter a search term.',
    currentTime: 'Current Time',
    wait: 'Please wait...',
    noData: 'No data available.',
    comingSoon: 'Coming Soon',
    logoutConfirmTitle: 'Logout',
    logoutConfirmMessage: 'Are you sure you want to logout?',
    save: 'Save',
    delete: 'Delete',
    deleteSuccess: 'Deleted successfully.',
    edit: 'Edit',
    reset: 'Reset',
    actions: 'Actions',
    action: 'Action',
    rowsPerPage: 'Rows per page',
    of: 'of',
    allStatus: 'All Status',
    allTypes: 'All Types',
    add: 'Add New',
    status: 'Status',
    close: 'Close',
    more: 'More',
    saving: 'Saving...',
    updating: 'Updating...',
    retry: 'Retry',
    deleting: 'Deleting...',
    success: 'Success',
    remark: 'Remark',
    language: 'Language',
    clearAllFilters: 'Clear All Filters',
    hideFilters: 'Hide Filters',
    showFilters: 'Show Filters',
    warning: 'Warning',
    information: 'Information',
    forbidden: 'Access Forbidden',
    notFound: 'Resource Not Found',
    badRequest: 'Bad Request',
    loading: 'Loading...',
    processing: 'Processing...',
    checkingAuthentication: 'Checking Authentication...',
    verify: 'Verify',
    preparing: 'Preparing',
    loggingOut: 'Logging out...',
    startDate: 'Start Date',
    endDate: 'End Date',
    excel: 'Excel',
    columnSelection: 'Column Selection',
    columnSettings: 'Column Settings',
    selectAll: 'Select All',
    unselectAll: 'Unselect All',
    totalItems: 'Total Items',
    items: 'items',
    selectedItems: 'Selected Items',
    itemsSelected: '{{count}} item(s) selected',
    noItemsSelected: 'No items selected',
    batchSettings: 'Batch Settings',
    apply: 'Apply',
    applied: 'Applied',
    totalQty: 'Total Qty',
    remainingQty: 'Remaining Qty',
    workQty: 'Work Qty',
    split: 'Split',
    existing: 'Existing',
    processing: 'Processing...',
    saving: 'Saving...',
    selectDateRange: 'Select Date Range',
    customRange: 'Custom Range',
    dateRanges: {
      today: 'Today',
      yesterday: 'Yesterday',
      thisWeek: 'This Week',
      lastWeek: 'Last Week',
      thisMonth: 'This Month',
      lastMonth: 'Last Month',
      last7Days: 'Last 7 Days',
      last30Days: 'Last 30 Days',
      last90Days: 'Last 90 Days'
    },
    searchType: 'Search Type',
    searchKeyword: 'Enter search keyword',
    all: 'All',
    unauthorized: 'Unauthorized',
    noAccessRights: 'You do not have access rights to this page',
    error: 'Error',
    refresh: 'Refresh',
    no: 'No',
    date: 'Date',
    complete: 'Complete',
    register: 'Register',
    print: 'Print',
    printPreview: 'Print Preview',
    start: 'Start',
    saveAndClose: 'Save and Close',
    statusCode: 'Status Code',
    underConstruction: 'Under Construction',
    searchConditions: 'Search Conditions',
    search: 'Search',
    searching: 'Searching...',
    currentTime: 'Current Time',
    noResults: 'No results found',
    additionalFilters: 'Additional Filters',
    searchFields: {
      styleNo: 'Style No',
      item: 'Item',
      color: 'Color',
      customer: 'Customer',
      buyer: 'Buyer',
      dyeingNo: 'Dyeing No',
      productionNo: 'Production No',
      orderNo: 'Order No',
      fileNo: 'File No',
      factory: 'Factory',
      name: 'Contact',
      size: 'Size',
      quantity: 'Quantity',
      status: 'Status',
      search: 'Search'
    },
    list: {
      title: 'List'
    },
    select: 'Select',
    columns: {
      no: 'No',
      id: 'ID',
      date: 'DATE',
      requestAt: 'REQ@',
      recipeAt: 'RECIPE@',
      orderNo: 'Order No',
      size: 'SIZE',
      color: 'COLOR',
      qty: 'QTY',
      cheese: 'CHEESE',
      workType: 'Work Type',
      misc: 'REMARK',
      confirmType: 'Confirm Type',
      stockType: 'Stock Type',
      urgent: 'URGENT',
      workProcess: 'Work Process',
      sample: 'SAMPLE',
      workStartDate: 'START DATE',
      dyeingNo: 'DYEING NO',
      recipeId: 'RECIPE ID',
      windingNo: 'WINDING NO',
      targetDate: 'TARGET DATE',
      planDate: 'PLAN DATE',
      delivery: 'DELIVERY',
      rackCode: 'RACK CODE',
      operation: 'OPERATION',
      styleNo: 'STYLE',
      style: 'STYLE',
      item: 'ITEM',
      factory: 'FACTORY',
      remark: 'REMARK',
      productionNo: 'PRODUCTION NO',
      workChees: 'WORK CHEES',
      recipe: 'RECIPE',
      mc: 'M/C',
      workStatus: 'STATUS',
      lot: 'LOT',
      factory: 'FACTORY',
      vendor: 'VENDOR',
      customer: 'CUSTOMER'
    },
    modify: 'Modify',
    creating: 'Creating...',
    modifying: 'Modifying...',
    yes: 'Yes',
    no: 'No'
  },

  menu: {
    notices: 'Notices',
    orderManagement: 'Order',
    orderInput: 'Order Input',
    orderModify: 'Order Modify',
    workOrder: 'Order Status',
    orderSearch: 'Order Search',
    swatchManagement: 'Sample Send & Confirm',
    invoiceIssuance: 'Invoice Issuance',
    invoiceManagement: 'Invoice Management',
    paymentManagement: 'Payment Management',
    dyeingManagement: 'Dyeing',
    dyeingWork: 'Dyeing Request',
    dyeingOperation: 'Dyeing Work',
    dyeingStatus: 'Dyeing Status',
    recipeSearch: 'Recipe Search',
    windingManagement: 'Winding',
    windingRequest: 'Winding Request',
    windingOperation: 'Winding Operation',
    windingStatus: 'Winding Status',
    shippingDelivery: 'Delivery',
    shippingRequest: 'Shipping Request',
    shippingOperation: 'Shipping Operation',
    shippingTracking: 'Shipping Tracking',
    workRequest: 'Work Request',
    financeManagement: 'Finance Management',
    financeOverview: 'Finance Overview',
    inventoryManagement: 'Inventory',
    inventory: {
      balance: 'Inventory Balance',
      lotBatch: 'LOT Management',
      transactionHistory: 'Inventory Tx History',
      transfer: 'Inventory Transfer',
      adjustment: 'Inventory Movement',
      batchInput: 'Batch Input'
    },
    scmManagement: 'Supply Chain',
    scm: {
      goodsReceipt: 'GR Registration',
      goodsIssueList: 'GI Status',
      goodsIssueRegistration: 'GI Registration',
      deliveryInfo: 'Delivery Registration',
      deliveryStatus: 'Delivery Status'
    },
    masterData: 'Master Data',
    masterDataMenu: {
      item: 'Item',
      uomConversion: 'UOM & Conversion',
      location: 'Warehouse Location',
      supplier: 'Supplier Registration',
      itemTaxon: 'Item Classification',
      customer: 'Customer',
      buyer: 'Buyer'
    },
    expand: "Expand Menu",
    collapse: "Collapse Menu",
    admin: {
      title: 'Admin',
      userManagement: {
        title: 'User Management',
        registration: 'Registration Management',
        resetPassword: 'Password Reset',
        accessLogs: 'Access Logs',
        sendMessage: 'Send Message'
      },
      standardsManagement: {
        title: 'Standards Management',
        threads: 'Item Management',
        companies: 'Company Management',
        buyers: 'Buyer Management',
        prices: 'Price Management',
        sizes: 'Size(M) Management',
        machine: 'Machine Management'
      },
      materialsManagement: {
        title: 'Materials Management',
        yarn: 'Yarn Management',
        dye: 'Dye Management',
        inventory: 'Inventory Management'
      },
      bi: {
        title: 'BI'
      }
    }
  },
  giRequest: {
    shippingMarkNote: {
      title: 'Shipping Mark Note',
      placeholder: 'Enter text to show on the shipping mark',
      download: 'Download',
      instruction: 'Drag styles to move them between groups. Leave the text empty to show the CITY.',
      group: 'Group {{n}}',
      addGroup: 'Add Group',
      removeGroup: 'Remove Group',
      styleCount: '{{count}} styles',
      emptyGroup: 'Move styles into this group',
      autoGroupByRemark: 'Auto Group by REMARK',
      columns: {
        style: 'STYLE',
        fileNo: 'FILE NO',
        item: 'ITEM',
        size: 'SIZE',
        dyeingNo: 'DYEING NO',
        color: 'COLOR',
        qty: 'QTY',
        remark: 'REMARK'
      }
    },
    tabs: {
      general: 'General GI',
      batch: 'Bulk Request',
      bulkList: 'GI Groups',
      dailyCalendar: 'Daily Calendar',
      requestStatus: 'Request Status'
    },
    row: {
      requested: 'Requested',
      partial: 'Partial',
      fullyRequestedHint: 'Fully GI-requested\nCannot add more'
    },
    qtyErrors: {
      title: 'Cannot issue GI request',
      empty: 'Qty is empty.',
      invalid: 'Qty is not a valid number.',
      negative: 'Qty must be 0 or greater.',
      zero: 'Qty must be greater than 0.',
      decimal: 'Qty allows only up to 2 decimal places.',
      exceed: 'Qty exceeds the order quantity.',
      generalSummary: 'Qty exceeds the order quantity.',
      generalLineRemain: 'Sub-order {{subId}}: input {{qty}} > remaining {{remain}} (order {{order}}, already requested {{requested}})',
      generalLineOrder: 'Sub-order {{subId}}: input {{qty}} > order qty {{order}}'
    },
    bulkList: {
      fromDate: 'From',
      toDate: 'To',
      giNo: 'GI No.',
      delivery: 'Delivery',
      plannedDate: 'Planned Date',
      lineCount: 'Lines',
      lineCountChip: '{{count}}',
      summary: 'Summary',
      subOrder: 'Sub Order',
      styleNo: 'Style',
      vendor: 'Vendor',
      dyeingNo: 'Dyeing No.',
      color: 'Color',
      item: 'Item',
      qty: 'Qty',
      downloadPackingList: 'Download Packing List',
      downloadPackingListExim: 'Packing List (EXIM)',
      downloadPackingListAccount: 'Packing List (ACCOUNTING)',
      downloadShippingMark: 'Shipping Mark',
      searchPrompt: 'Press Search to load data.',
      dateRequired: 'Please enter both start and end dates.',
      invalidDateRange: 'Start date cannot be later than end date.',
      noLineToDownload: 'No lines to download.',
      deleteGi: 'Delete GI Group',
      deleteTitle: 'Delete GI Group',
      deleteConfirm: 'Delete {{giNo}} ({{count}} lines)? This action cannot be undone.',
      deleteAskShort: 'Delete {{giNo}}?',
      deleteBlockedTitle: 'Cannot Delete GI Group',
      deleteBlockedMessage: '{{giNo}} cannot be deleted.',
      deleteBlockedHeading: 'Warning',
      deleteBlockedBody: 'This GI has linked invoices. Once invoices are issued, the GI group cannot be deleted.',
      deleteBlockedBody1: 'This GI has linked invoices.',
      deleteBlockedBody2: 'Once invoices are issued, the GI group cannot be deleted.',
      deleteInvoiceWarn: 'Warning: This GI is linked to invoices ({{nos}}). Deletion may affect invoice display consistency.',
      deleteSuccess: 'GI group has been deleted.',
      deleteFailed: 'Failed to delete the GI group.',
      deleteLine: 'Delete shipment',
      lineDeleteTitle: 'Delete Shipment',
      lineDeleteAsk: 'Delete sub_order {{subOrder}} shipment from {{giNo}}?',
      lineDeleteSuccess: 'Shipment has been deleted.',
      lineDeleteFailed: 'Failed to delete the shipment.',
      dailyTotalsHeading: 'Daily GI Request Totals'
    },
    box: {
      tabSubOrder: 'Sub-order Summary',
      tabBox: 'Boxes',
      boxNo: 'Box No.',
      originalNo: 'Original No.',
      finalNo: 'Final No.',
      status: 'Status',
      merged: 'Merged',
      summary: '{{boxes}} physical boxes ({{rows}} rows)',
      countChip: '{{count}} boxes',
      customBadge: 'Renumbered',
      none: 'This GI request has no box numbers yet.',
      generate: 'Generate Box Numbers',
      edit: 'Edit Numbers',
      editTitle: 'Edit Box Numbers',
      save: 'Save',
      regenerate: 'Regenerate',
      regenerateTitle: 'Regenerate Boxes',
      regenerateConfirm: 'All edited box numbers will be cleared. Continue?',
      previewHint: 'Numbers are renumbered from 1 on save. Check the Final No. column.',
      loadFailed: 'Failed to load box information.',
      saveFailed: 'Failed to save box numbers.',
      generateFailed: 'Failed to generate box numbers.',
      conflict: 'Another user updated boxes first. Reloading.',
      lineDeleteRenumberWarn: 'Box numbers will be renumbered from 1.',
      applyStyleOrder: 'Tidy Box Numbers',
      multiGiPackingNotice: 'Multiple GI requests are included, so CT numbers will be concatenated.'
    },
    mergePicker: {
      title: 'Choose Merge Target',
      description: 'Multiple existing GI requests share the same delivery and planned date.\nChoose which one to merge lines into, or create a new request.',
      currentDelivery: 'Current Delivery',
      currentItemsHeading: 'Lines to Add',
      conflictNotice: '⚠ The shipment(s) you are adding already exist in another GI request.\nTo avoid duplicates, you can only merge into that request. To choose another or create a new one, delete (🗑) the existing shipment first.',
      markDelete: 'Delete this shipment (applied on confirm)',
      cancelDelete: 'Undo delete',
      plannedDate: 'Planned Date',
      lineCount: 'GI Count',
      createNew: 'Create as a new GI request',
      summaryTitle: 'Selected GI Request Detail',
      linesHeading: 'GI List',
      remarks: 'Remarks'
    },
    form: {
      title: 'Create GI Request',
      editTitle: 'Edit GI Request',
      confirmAddTitle: 'Create GI Request',
      confirmAddMessage: 'Do you want to create this GI request?',
      addSuccess: 'GI request has been created successfully.',
      confirmEditTitle: 'Update GI Request',
      confirmEditMessage: 'Do you want to save the changes?',
      editSuccess: 'GI request has been updated successfully.',
      deliveryId: 'Delivery ID',
      plannedDispatchAt: 'Planned Dispatch Date',
      remarks: 'Remarks',
      lines: 'Line Details',
      lineLabel: 'Line {{index}}',
      docType: 'Document Type',
      docRefNo: 'Reference No.',
      item: 'Item',
      qty: 'Quantity',
      lotId: 'Lot',
      locationFrom: 'Location From',
      rackFrom: 'Rack',
      separatePacking: 'Separate Packing',
      splitShipment: 'Split Shipment',
      splitShipmentHint: 'Split the same sub-order with a different dispatch date and quantity',
      removeSplitGroup: 'Cancel Split',
      deliveryInfo: 'Delivery Information',
      deliveryName: 'Delivery Name',
      deliveryPartnerId: 'Partner ID',
      deliveryPartnerName: 'Partner Name',
      deliveryPartnerCode: 'Partner Code',
      deliveryShippingMark: 'Shipping Mark',
      deliveryDistrict: 'District',
      deliveryAddress: 'Address',
      deliveryAddress2: 'Address 2',
      deliveryPostcode: 'Postcode',
      deliveryCountryCode: 'Country Code',
      deliveryTaxId: 'Tax ID',
      deliveryTaxType: 'Tax ID Type',
      deliveryCustomsId: 'Customs ID',
      deliveryCustomsType: 'Customs ID Type',
      deliverySpecification: 'Specification',
      deliveryCreatorRegion: 'Creator Region',
      deliveryCreatedAt: 'Created At',
      deliveryUpdatedAt: 'Updated At'
    },
    displayFilter: 'Display Filter',
    incomplete: 'Incomplete',
    requestable: 'Requestable',
    displayFilter: 'Display Filter',
    incomplete: 'Incomplete',
    requestable: 'Requestable',
    createRequest: 'GI Request',
    completedFilterTooltip: 'When on, rows with GI Req. quantity are hidden.',
    editRequest: 'Edit GI Request',
    updateRequest: 'Update GI Request',
    editInGeneralTab: 'Please edit and delete in the General Request tab.',
    request: 'GI Request',
    vendor: 'Vendor',
    manager: 'Contact',
    unknownItem: 'Unknown Item',
    totalRequestsWillBeCreated: 'A total of {{count}} GI request(s) will be created.',
    validation: {
      qtyEmpty: 'Quantity for "{{itemName}}" in GI Request {{requestNumber}} is empty.',
      qtyInvalid: 'Quantity "{{qtyValue}}" for "{{itemName}}" in GI Request {{requestNumber}} cannot be converted to a number.',
      qtyNegative: 'Quantity for "{{itemName}}" in GI Request {{requestNumber}} must be 0 or greater.',
      qtyDecimalPlaces: 'Quantity for "{{itemName}}" in GI Request {{requestNumber}} can only have up to 2 decimal places.',
      qtyInputError: 'Quantity input error occurred.'
    },
    errors: {
      createFailed: 'Failed to create GI request.',
      createError: 'An error occurred while creating GI request.',
      partialCreateFailed: 'Some GI requests failed to be created.',
      errorDetail: '- Vendor ID: {{vendorId}}, Delivery ID: {{deliveryId}}\n  Error: {{error}}'
    },
    list: {
      title: 'GI Request List',
      id: 'Request ID',
      plannedDispatchAt: 'Planned Dispatch Date',
      plannedFrom: 'Plan From',
      plannedTo: 'Plan To',
      delivery: 'Delivery',
      remarks: 'Remarks',
      approval: 'Approval',
      lines: 'Lines',
      searchPlaceholder: 'Search by request ID, delivery, remarks',
      qtyLabel: '{{qty}} EA',
      approved: 'Approved',
      pendingApproval: 'Pending Approval'
    },
    validation: {
      required: 'Please fill in the required information.',
      lineRequired: 'Each line requires item and quantity.'
    },
    errors: {
      generic: 'Failed to process GI request.'
    },
    packingList: {
      dialogTitle: 'Packing List Download',
      dialogTitleExim: 'Packing List Download (EXIM)',
      dialogTitleAccount: 'Packing List Download (ACCOUNTING)',
      dialogTitleShippingMark: 'Shipping Mark Download',
      accountFileSplit: 'Split downloads by Customer / Manager / Delivery',
      dialogDescription: 'Select exchange rate option for price conversion (USD → IDR)',
      useOrderRate: 'Use order exchange rate',
      notSet: 'not set',
      manualInput: 'Manual input :',
      manualPlaceholder: 'e.g. 15800',
      noConversion: 'No conversion (USD only)',
      download: 'Download',
      cancel: 'Cancel',
      downloadFailed: 'Packing List download failed.',
      buttonTooltip: 'Packing List Excel Download'
    }
  },

  orders: {
    title: 'Order Basic Information Input',
    detailTitle: 'Order Details',
    modifyTitle: 'Order Modify',
    tabs: {
      sales: 'Sales Order',
      basic: 'Basic',
      internalProduction: 'Internal Production'
    },
    internal: {
      inputTitle: 'Internal Production Order Input',
      listTitle: 'Internal Production Order List',
      vendorFixedHint: 'Vendor is fixed for internal production orders.'
    },
    list: {
      title: 'Order List',
      searchPlaceholder: 'Search by Order ID, Customer, Buyer, Style, etc...'
    },
    search: {
      orderNumberLabel: 'Order Number',
      orderNumberPlaceholder: 'Please enter order number (e.g.: 202512260)',
      enterOrderNumber: 'Please enter an order number.',
      orderOrStyleLabel: 'Order No / Style No',
      orderOrStylePlaceholder: 'Enter order number or style number (digits only: search both, with letters: style only)',
      enterOrderOrStyle: 'Please enter an order number or style number.',
      noResults: 'No search results found.',
      resultsFound: '{{count}} results found.'
    },
    subOrder: {
      detail: {
        title: 'Sub-Order Detail Information',
        subOrderId: 'Sub-Order ID',
        fetchError: 'Failed to fetch sub-order information.',
        basicInfo: 'Basic Information',
        detailInfo: 'Detail Information',
        dyeingRequest: 'Dyeing Request',
        dyeingRequestBefore: 'Before Dyeing Request',
        swatchInfo: 'Swatch Information',
        dyeingProcess: 'Dyeing Process',
        dyeingProcessEvent: 'Dyeing Process Event',
        windingProcess: 'Winding Process',
        windingProcessEvent: 'Winding Process Event',
        noProcess: 'No Process',
        noEvent: 'No Event',
        work: 'Work',
        value: 'Value',
        eventTime: 'Time',
        sharedRun: 'Batch',
        sharedRunHint: 'Recipe batch event recorded on another dyeing number',
        eventsTruncated: 'Only the latest 1,000 process events are shown.',
        processActivityLoadFailed: 'Failed to load process events and inventory movements.',
        inventoryTx: {
          title: 'Inventory movements',
          empty: 'No inventory movements.',
          loadFailed: 'Failed to load inventory movements.',
          loadMore: 'Load more',
          workType: 'Process',
          work: 'Work'
        },
        orderId: 'Order ID',
        buyer: 'Buyer',
        vendor: 'Vendor',
        manager: 'Manager',
        delivery: 'Delivery',
        styleNo: 'Style No',
        fileNo: 'File No',
        orderReceivedDate: 'Order Received Date',
        orderCreator: 'Order Creator',
        attachedFiles: 'Attached Files',
        threadName: 'Thread Name',
        size: 'Size',
        itemName: 'Item Name',
        color: 'Color',
        quantity: 'Quantity',
        unitPrice: 'Unit Price',
        totalAmount: 'Total Amount',
        currency: 'Currency',
        createdAt: 'Created At',
        rawYarn: 'Raw Yarn',
        dyeingNo: 'Dyeing No',
        dyeingRequestType: 'Dyeing Request Type',
        requestCheeseNum: 'Request Cheese Number',
        repeat: 'Repeat',
        urgent: 'URGENT',
        confirm: 'Confirm',
        requester: 'Requester',
        requestDate: 'Request Date',
        remark: 'Remark',
        swatchQty: 'Swatch Quantity',
        swatchSize: 'Swatch Size',
        swatchRemark: 'Swatch Remark',
        productionId: 'Production ID',
        recipeId: 'Recipe ID',
        cheeseNum: 'Cheese Number',
        machineNo: 'Machine No',
        status: 'Status',
        dyeingStart: 'Dyeing Start',
        dyeingEnd: 'Dyeing End',
        storage: 'Storage',
        lastUpdate: 'Last Update',
        eventName: 'Event Name',
        author: 'Author',
        value1: 'Value 1',
        value2: 'Value 2',
        windingId: 'Winding ID',
        requestQty: 'Request Quantity',
        productionQty: 'Production Quantity',
        deliveryQty: 'Delivery Quantity',
        targetDate: 'Target Date',
        plannedDate: 'Planned Date',
        dryingRequired: 'Drying Required',
        departureTime: 'Departure Time',
        arrivalTime: 'Arrival Time',
        giRequest: 'GI Request',
        giRequestId: 'GI Request ID',
        plannedDispatchAt: 'Planned Dispatch Date',
        giRequestLines: 'GI Request Lines',
        lineNo: 'Line No',
        docType: 'Document Type',
        docRefNo: 'Reference No',
        qty: 'Quantity',
        lotId: 'LOT ID',
        locationFrom: 'Location From',
        rackFrom: 'Rack',
        giRequestBefore: 'No GI request information available.',
        giLot: 'GI LOT',
        lotNo: 'LOT No',
        expectedGiAt: 'Expected GI Date',
        workShift: 'Work Shift',
        docId: 'Document ID',
        address: 'Address',
        attributes: 'Attributes',
        qtyBox: 'Box Qty',
        mfgDate: 'Manufacturing Date',
        expiryDate: 'Expiry Date',
        qcStatus: 'QC Status',
        giLotBefore: 'No GI LOT information available.',
        giPost: 'GI Post',
        giPostId: 'GI Post ID',
        giPostNo: 'GI Post No',
        outboundLotNo: 'Outbound LOT No',
        giTime: 'GI Time',
        customsDocNo: 'Customs Doc No',
        createdBy: 'Created By',
        giPostBefore: 'No GI Post information available.'
      }
    },
    addItem: 'Add Item',
    fields: {
      orderNo: 'No',
      customer: 'Customer',
      factory: 'Factory',
      contact: 'Contact',
      buyer: 'Buyer',
      buyer_detail: 'Buyer Detail',
      styleNo: 'Style No',
      fileNo: 'File No',
      orderReceivedDate: 'Order Received Date',
      expectedDeliveryDate: 'Expected Delivery Date',
      fx_base_currency: 'FX Base Currency',
      fx_quote_currency: 'FX Quote Currency',
      fx_rate: 'FX Rate',
      fetchFxRate: 'Fetch official rate',
      applyFxRate: 'Apply rate',
      fxRateFetchFailed: 'Failed to fetch exchange rate.',
      date: 'Date',
      item: 'Item',
      size: 'Size',
      color: 'Color',
      quantity: 'Quantity',
      currency: 'Currency',
      unitPrice: 'Unit Price',
      noPriceData: 'No price data',
      priceSelectTitle: 'Select Price',
      code: 'Code',
      totalPrice: 'Total Price',
      actions: 'Actions',
      orderInfo: 'Order Information',
      searchConditions: 'Search Conditions',
      weight: 'Weight',
      items: 'Items',
      orderDate: 'Order Date',
      total: 'Total',
      sum: 'Sum',
      remark: 'Remark',
      searchOrderId: 'Enter order ID'
    },
    workType: {
      swatch: 'SWATCH',
      repeat: 'REPEAT'
    },
    confirmationType: {
      vendor: 'VENDOR',
      self: 'SELF'
    },
    stockType: {
      na: 'N/A',
      stock_black: 'STOCK BLACK',
      opt: 'OPT',
      opt_white: 'OPT',
      ivory: 'IVORY'
    },
    columns: {
      no: 'No',
      date: 'Date',
      orderNo: 'Order No',
      custom: 'Customer',
      buyer: 'Buyer',
      styleNo: 'Style No',
      fileNo: 'FILE NO.',
      vendorName: 'CUSTOMER',
      factory: 'Factory',
      name: 'Contact',
      item: 'Item',
      size: 'Size',
      color: 'Color',
      dyeNo: 'Dyeing No',
      dyeingStatus: 'Dyeing status',
      yarnEa: 'Yarn Ea',
      inventory: 'Inventory',
      totalQty: 'Total Qty',
      unitPrice: 'Unit Price',
      totalPrice: 'Total Price',
      swatchDate: 'Swatch Date',
      sampleDate: 'Sample Date',
      confirmDate: 'Confirm Date',
      shippingDate: 'Shipping Date',
      deliveryDate: 'GI Date',
      shippedQty: 'Shipped Qty',
      remainingQty: 'Remaining Qty',
      shippingSampleDate: 'Shipping Sample Date',
      remark: 'Remark',
      status: 'Status'
    },
    validation: {
      required: 'Required field',
      invalidNumber: 'Invalid number'
    },
    messages: {
      saveSuccess: 'Order saved successfully',
      saveSuccessWithFileUpload: 'Order ID: {{orderId}}\nOrder saved successfully.',
      saveFail: 'Failed to save order',
      errorOrderId: 'Order ID is required',
      searchSuccess: 'Order information loaded successfully',
      deleteSuccess: 'Order deleted successfully',
      deleteFail: 'Failed to delete order',
      deleteConfirm: 'Are you sure you want to delete this order?',
      updateSuccess: 'Order updated successfully'
    },
    delete: {
      title: 'Delete Order',
      confirmMessage: 'Are you sure you want to delete this order?'
    },
    confirm: {
      title: 'Confirm',
      editTitle: 'Confirm Changes'
    },
    files: {
      title: 'Attached Files',
      selectTooltip: 'Upload files',
      selectedCount_one: '{{count}} file selected',
      selectedCount_other: '{{count}} files selected',
      uploading: 'Uploading files...',
      loading: 'Loading files...',
      uploadErrorTitle: 'File Upload Failed',
      uploadFailure: 'Order ID: {{orderId}}\nFile upload failed.\nFailed files: {{failedFiles}}',
      uploadPartialFailure: 'Order ID: {{orderId}}\nSome files failed to upload.\nSuccess: {{successCount}}/{{totalCount}}\nFailed files: {{failedFiles}}',
      noFiles: 'No attached files.',
      existingFile: 'Existing File'
    },
    viewMode: {
      on: 'Ex',
      off: 'Basic'
    },
    filterAddCurrent: 'Add current selection to filter',
    customerRequired: 'Please select a customer first.',
    statusTabs: {
      basic: 'Basic',
      detail: 'Detail'
    },
    selfConfirm: 'CFM SAMJIN',
    myOrderFilter: {
      on: 'My',
      off: 'All'
    },
    orderStatus: {
      columns: {
        scmDeliveryStatus: 'Delivery Status',
        scmDeliveryDate: 'Delivery Date',
        scmDeliveryQty: 'Delivery Qty'
      },
      errors: {
        deliveryFetchFailed: 'Failed to load delivery information.'
      }
    },
    columnSettings: 'Column Settings',
    status: {
      pending: 'Pending',
      swatchWaiting: 'Swatch Waiting',
      dyeingWaiting: 'Dyeing Waiting',
      processWaiting: 'Process Waiting',
      inProgress: 'In Progress',
      rework: 'Rework',
      completed: 'Completed',
      checkingResult: 'Color Checking',
      dehydrationWaiting: 'Dehydration Waiting',
      dehydrationInProgress: 'Dehydration In Progress',
      dehydratingInProgress: 'Dehydrating In Progress',
      locationNeeded: 'Location Assignment Needed',
      rackingWaiting: 'Racking Waiting',
      stacking: 'Stacking',
      vendorChecking: 'Vendor Checking',
      vendorConfirmed: 'Vendor Confirmed',
      vendorRejected: 'Vendor Rejected',
      colorRejected: 'Color Rejected',
    },
    confirm: {
      title: 'Confirm',
    }
  },

  swatch: {
    shippingSampleComingSoon: 'Coming soon',
    flow: {
      noProcess: 'No process history.',
      dyeWaiting: 'Dyeing Waiting',
      dyeingInProgress: 'Dyeing',
      recipeAdding: 'Adding Recipe',
      rackWaiting: 'Storage Waiting',
      redyed: 'Re-dyed',
      workCancelled: 'Cancelled',
      waiting: 'Waiting',
      approved: 'Approved',
      rejected: 'Rejected',
      colorFailed: 'Color Failed',
      send: 'Send',
      sendCancel: 'Cancel Send',
      approve: 'Approve',
      reject: 'Reject',
      resultCancel: 'Cancel Result',
      remaining: 'Remaining Qty',
      undecided: 'Undecided'
    },
    filterTitle: 'Search Conditions',
    noData: 'No data available.',
    fields: {
      customer: 'Customer',
      buyer: 'Buyer',
      styleNo: 'Style No',
      fileNo: 'File No',
      factory: 'Factory',
      manager: 'Contact',
      item: 'Item',
      color: 'Color',
      quantity: 'Quantity'
    },
    columns: {
      subOrderId: 'Sub Order ID',
      customer: 'Customer',
      buyer: 'Buyer',
      styleNo: 'Style No',
      fileNo: 'File No',
      factory: 'Factory',
      manager: 'Contact',
      item: 'Item',
      color: 'Color',
      quantity: 'Quantity',
      activeProductionId: 'Active Production ID',
      activeStatus: 'Active Status',
      rejectCount: 'Reject #',
      confirmStatus: 'Confirm',
      actions: 'Actions',
      productionId: 'Production ID',
      status: 'Status',
      updatedAt: 'Updated At',
      dyeingNo: 'DYEING NO'
    },
    vendorConfirm: {
      title: 'Vendor Confirm Registration ({{count}} items)',
      selectedItemInfo: 'Selected Item Information',
      dyeingWorkHistory: 'Dyeing Work History and Vendor Confirm',
      vendorConfirm: 'Vendor Confirm',
      processing: 'Processing...',
      pleaseWait: 'Please wait a moment',
      register: 'Confirm',
      edit: 'Edit',
      confirm: 'Confirm',
      reject: 'Reject',
      selfConfirm: 'Self Confirm',
      selfReject: 'Self Reject',
      sendSample: 'Send Sample',
      vendorApprove: 'Vendor Confirm',
      vendorReject: 'Vendor Reject',
      select: 'Select',
      statusChecking: 'Vendor Checking',
      statusStored: 'In Storage',
      statusDone: 'Completed',
      statusRejected: 'Rejected',
      decision: 'Decision',
      undecided: 'Undecided',
      rejected: 'Rejected',
      noItemsToModify: 'No items to modify.',
      vendorConfirmRegistered: 'Vendor confirm has been registered.',
      registrationFailed: 'Failed to register vendor confirm: {{error}}',
      cancelReview: 'Cancel Review',
      cancelFailed: 'Failed to send cancel event: {{error}}'
    },
    tableControls: {
      itemsSelected: '{{count}} items selected',
      noItemsSelected: 'No items selected',
      vendorConfirmTooltip: 'Vendor Confirm Registration ({{count}})',
      columnSettings: 'Column Settings',
      selectAll: 'Select All',
      unselectAll: 'Unselect All'
    },
    detail: {
      title: 'Swatch Detail',
      basicInfo: 'Basic Information',
      statusApproved: 'Approved',
      statusRejected: 'Rejected',
      statusPending: 'Pending',
      fields: {
        subOrderId: 'Sub Order ID',
        dyeingNo: 'Dyeing NO',
        customer: 'Customer',
        buyer: 'Buyer',
        styleNo: 'Style No',
        fileNo: 'File No',
        factory: 'Factory',
        manager: 'Contact',
        item: 'Item',
        color: 'Color',
        quantity: 'Quantity'
      },
      summary: {
        title: 'Dyeing Progress Summary',
        dyeingNo: 'Dyeing NO',
        activeProductionId: 'Active Production ID',
        activeStatus: 'Active Status',
        rejectCount: 'Reject #',
        confirmStatus: 'Confirm',
        confirmed: 'Confirmed',
        notConfirmed: 'Not Confirmed'
      },
      history: {
        title: 'Dyeing Work History',
        productionId: 'Production ID',
        status: 'Status',
        statusDesc: 'Status Description',
        updatedAt: 'Updated At',
        remark: 'Remark',
        empty: 'No dyeing work history.'
      }
    }
  },

  dyeing: {
    title: 'Dyeing Work',
    tabs: {
      batchRequest: 'Bulk Request',
      internalProduction: 'Internal Production',
      requestStatus: 'Request Status'
    },
    assignWork: 'Assign Work',
    fields: {
      searchConditions: 'Search Conditions',
      dyeingNo: 'Dyeing No',
      productionNo: 'Production No'
    },
    requests: {
      request: 'Assign',
      delete: 'Delete',
      modify: 'Modify',
      createDyeingNumbers: 'Create Dyeing Numbers'
    },
    worker: {
      enterUserId: 'Please enter your user ID to connect.',
      userId: 'User ID',
      retryConnection: 'Reconnect',
      tokenExpired: 'Connection expired. Please reconnect with the button below.',
      tokenFailed: 'Failed to receive access token.',
      userNotFound: 'User ID does not exist.',
      operator: 'Operator',
      showHistory: 'Show completed / rejected',
      invalidCredentials: 'Administrator approval is required.\nPlease contact your administrator.',
      networkError: 'Unable to reach server. Please check your network.',
      loginButton: 'Sign In',
      loadingWork: 'Loading work...',
      recipeLocked: 'Recipe cannot be changed during dyeing process',
      searchResultTitle: 'Search Results',
      searchNoResult: 'No results found.'
    },
    status: {
      showCompleted: 'Show completed'
    },
    messages: {
      updateSuccess: 'Dyeing request updated successfully',
      updateFail: 'Failed to update dyeing request',
      abnormalSelection: 'There are some abnormal items in the selection',
      deleteSuccess: 'Dyeing request deleted successfully',
      deleteFail: 'Failed to delete dyeing request',
      deleteFailed: 'Delete failed',
      requestSuccess: 'Dyeing request sent successfully',
      requestFail: 'Failed to send dyeing request',
      noNewItems: 'No new items selected',
      onlyNewItems: 'Only new items can be registered',
      selectItemsToPrint: 'Please select items to print',
      noDyeingItemsSelected: 'No dyeing items selected',
      missingSampleDetails: 'SAMPLE SIZE or QTY is not entered for some items',
      excelSheetWillBeAdded: 'Excel sheet will be added',
      noPrintableItems: 'No items to print',
      deleteConfirm: 'Are you sure you want to delete the dyeing request?',
      noItemsSelected: 'No items selected',
      selectItems: 'Please select items',
      invalidDeleteOrder: 'The following items cannot be deleted: {{items}}',
      dyeingReadyCompleted: 'Dyeing preparation completed.',
      dyeingStarted: 'Dyeing operation started.',
      dyeingFinished: 'Dyeing operation completed.',
      recipeLoadFailed: 'Failed to load recipe information.',
      saveFailed: 'Save failed.',
      recipeModifyCompleted: 'Recipe updated and returned to dyeing ready status.',
      operationCanceled: 'Dyeing operation canceled.',
      dehydrationStarted: 'Dehydration operation started.',
      dehydrationFinished: 'Dehydration operation completed.',
      colorConfirmed: 'Color has been confirmed.',
      colorDefectRecorded: 'Recorded as color defect. Modify recipe and re-dye (status 94).',
      dyeingAborted: 'Dyeing aborted. You can create new work numbers.',
      workRejected: 'Work has been rejected. Please create new work items',
      locationAssigned: 'Storage location has been assigned.',
      cannotModifyCompleted: 'Items that are already completed cannot be modified.',
      cannotModifyInProgress: 'Items that are in progress cannot be modified.',
      cannotDeleteCompleted: 'Items that are already completed cannot be deleted.',
      cannotDeleteInProgress: 'Items that are in progress cannot be deleted.',
      recipeSaveSuccess: 'Recipe saved successfully.',
      multiRecipeSaveSuccess: '{{successCount}} recipes saved successfully.',
      multiRecipeSavePartial: '{{successCount}} recipes saved, {{failCount}} failed.',
      recipeSaveFailed: 'Failed to save recipe.',
      productionIdsRequired: 'No SPK to add.',
      addingToExistingRecipe: 'Adding to existing recipe...',
      quantityChangeSuccess: 'Work quantity changed successfully.',
      selectOneItemForEdit: 'Please select only one item to edit',
      noRecipeToEdit: 'No recipe to edit',
      confirmDeleteRecipe: 'Are you sure you want to delete the recipe?',
      deleteRecipeFailed: 'Failed to delete recipe.',
      recipeDeleteSuccess: 'Recipe deleted successfully.',
      vendorColorConfirmed: 'Vendor color has been confirmed.',
      vendorRejected: 'Vendor rejected.',
      rawYarnNotSelected: 'There is a problem with raw yarn selection. Please regenerate or modify the dyeing request'
    },
    machine: {
      waiting: 'Waiting',
      working: 'Working',
      mcLabel: 'M/C {{number}}',
      mcNotAssigned: 'M/C Waiting',
      selectMachine: 'Assign M/C'
    },
    monitoring: {
      elapsedTime: 'Elapsed Time',
      exceededTimeLimit: 'Exceeded Time Limit',
      noActiveDyeing: 'No Active Dyeing',
      nextWork: 'Next Work',
      filterStatus: 'Filter Status',
      filterAll: 'All Machines',
      filterIdle: 'Idle Machines',
      filterWorking: 'Working Machines'
    },
    operation: {
      title: 'Dyeing Operation',
      operationTab: 'Operation',
      boilingRecordsTab: 'Boiling Records',
      startWork: 'Start Work',
      recordResult: 'Record Result',
      resultType: 'Result Type',
      notes: 'Notes',
      splitOrder: 'Split Order',
      totalQuantity: 'Total Quantity',
      splitQuantity: 'Split Quantity',
      splitHelp: 'Enter the quantity for the first lot',
      selectedItemsCount: '{{count}} items selected',
      noItemsSelected: 'No items selected',
      issueWorkNumber: 'Issue Work Number',
      delete: 'Delete',
      registerRecipe: 'Register Recipe',
      processQuantityDialog: {
        title: 'Set Work Quantity',
        dyeingNo: 'Dyeing No',
        totalOrderQuantity: 'Total Order Quantity',
        workQuantity: 'Work Quantity',
        workQuantityHelper: 'Enter the quantity to process this time (decimal allowed)',
        remainingQuantity: 'Remaining Quantity',
        remainingQuantityNote: '(Remaining quantity will be automatically created as a new work item)',
        applyExistingRecipe: 'Apply Existing Recipe (Optional)',
        selectRecipe: 'Select Recipe',
        doNotApply: 'Do Not Apply',
        recipeCopyNote: '* If selected, a recipe identical to the selected recipe will be automatically created.',
        enterWorkQuantity: 'Please enter work quantity.',
        workQuantityRange: 'Work quantity must be a number between 0 and {{max}}.',
        recipeCopyFailed: 'Work was created but recipe copy failed.',
        processQuantityFailed: 'Failed to set work quantity.'
      },
      batchDialog: {
        title: 'Batch Create Work/Recipe by Dyeing No',
        reworkTitleSuffix: ' (Using existing recipe {{recipeIdShort}})',
        reworkRunNumber: 'Current creation: recipe run {{n}}',
        reworkLabel: 'Current creation: rework',
        searchByDyeingNo: 'Search by dyeing number (dyeing_no_short)',
        unassignedOnly: 'Unassigned only',
        recipeSelect: 'Select Recipe',
        recipeNew: 'NEW',
        machineLabel: 'MC',
        machineNotSet: 'Not set',
        selectedItems: 'Selected Items',
        searchResults: 'Search Results',
        noData: 'No search results found.',
        createWorkOnly: 'Batch Create Work Number Only',
        createWorkAndRecipe: 'Work Number + Multi Recipe',
        noRowsSelected: 'No dyeing requests are selected or only items with 0 work quantity are selected.',
        submitFailed: 'An error occurred while creating work numbers.',
        headers: {
          dyeingNo: 'DYEING NO',
          style: 'STYLE',
          customer: 'CUSTOMER',
          item: 'ITEM',
          color: 'COLOR',
          reqQty: 'REQ QTY',
          workQty: 'WORK QTY',
          action: 'ACTION'
        },
        tooltips: {
          remove: 'Remove',
          select: 'Select',
          deselect: 'Deselect'
        }
      },
      editRecipe: 'Edit Recipe',
      printRecipe: 'Print Recipe',
      printCardsOnly: 'Print winding cards only',
      extraWindingCards: 'Extra winding cards (per item)',
      extraWindingCardsRequired: 'Please enter the number of extra cards to print.',
      netWeightMissingTitle: 'net_weight not registered',
      netWeightMissingBlocked: 'Please enter net_weight for {{items}} in the Item master. Recipe printing is blocked until registered.'
    },
    recipeRegisterOption: {
      title: 'Recipe Registration',
      subtitle: 'Select a registration method.',
      new: 'Create New',
      addToExisting: 'Add to Existing Recipe',
      copyDyeOnly: 'Copy Dyestuff Only from Existing Recipe'
    },
    addToExisting: {
      subtitle: 'Select a recipe to add.',
      recipeId: 'Recipe ID',
      dyeingNoShortList: 'Dyeing Number List',
      noRecipes: 'No recipes found.',
      loadError: 'Failed to load recipe list.',
      searchByDyeingNo: 'Search by dyeing number (dyeing_no_short)',
      searchAriaLabel: 'Search by dyeing_no_short'
    },
    boilingRecords: {
      startDateTime: 'Start Date/Time',
      endDateTime: 'End Date/Time',
      search: 'Search',
      dateRequired: 'Start and end date/time are required',
      invalidDateRange: 'Start date/time must be before end date/time',
      chartTitle: 'Boiling Period Timeline by Machine',
      noData: 'No boiling records found for the selected period',
      machineNo: 'Machine No',
      productionId: 'Production ID',
      dyeingNo: 'Dyeing No',
      recipeId: 'Recipe ID',
      boilingStart: 'Boiling Start',
      boilingEnd: 'Boiling End',
      duration: 'Duration',
      editDialogTitle: 'Edit Boiling Time',
      modify: 'Modify',
      modifySuccess: 'Boiling time has been updated.',
      modifyFailed: 'Failed to update boiling time.',
      zoomHelp: 'Use the zoom buttons or drag the chart to move (Zoom: {{zoom}}x)'
    },
    recipe: {
      title: 'Dyeing Recipe Registration',
      searchOrSelectDyestuff: 'Search/Select Dyestuff',
      addColorReductionRows: 'Add Color Reduction Rows',
      removeColorReductionRows: 'Remove Color Reduction Rows',
      enterNotes: 'Enter notes...',
      inventoryTx: {
        title: 'Inventory movements',
        empty: 'No inventory movements found.',
        loadFailed: 'Failed to load inventory movements.',
        loadMore: 'Load more',
        noProductionIds: 'No linked production IDs to query.',
        truncatedWorkIds: 'More than {{max}} productions — showing the first {{max}}.',
        columns: {
          txTime: 'Time',
          txType: 'Type',
          item: 'Item',
          qty: 'Qty',
          uom: 'UOM',
          from: 'From',
          to: 'To'
        }
      },
      totalPercent: 'TOTAL %',
      program: 'PROGRAM',
      addRevision: 'Add Revision',
      viewEdit: 'RECIPE',
      search: {
        title: 'Recipe Search'
      },
      fields: {
        recipeIdShort: 'Recipe ID (Short)',
        recipeId: 'Recipe ID',
        productionIds: 'Production IDs',
        dyeStuff: 'DYE STUFF',
        chemicals: 'CHEMICAL',
        acid: 'ACID',
        note: 'Note',
        createdBy: 'Created By',
        createdAt: 'Created At',
        dyeingNo: 'Dyeing No'
      },
      errors: {
        fetchFailed: 'Failed to fetch recipe list.'
      },
      selectedItemsCount: '{{count}} recipes selected',
      noItemsSelected: 'No recipes selected',
      selectionMode: 'Selection Mode',
      clickToSelect: 'Click to select',
      clickToDeselect: 'Click to deselect',
      clickToSelectAll: 'Click to select/deselect all',
      editRecipe: 'Edit Recipe',
      viewRecipe: 'Recipe Detail',
      savingMessage: 'Saving recipe information. Please wait...',
      multiRecipe: {
        title: 'Multi Dyeing Recipe Registration',
        sameWork: 'Same Work',
        workingDate: 'WORKING DATE',
        urgent: 'URGENT',
        customer: 'CUSTOMER',
        dyeingNo: 'DYEING NO',
        productionNo: 'PRODUCTION NO',
        color: 'COLOR',
        note: 'NOTE',
        dyeClass: 'Dye Class',
        item: 'Item',
        qty: 'Qty',
        net: 'Net(kg)',
        dyestuff: 'Dyestuff',
        percentage: '%',
        gram: 'Gram',
        total: 'TOTAL',
        chemical: 'CHEMICAL',
        rc: 'R/C',
        acid: 'ACID',
        selectItem: 'Select Item',
        acidSection: 'ACID',
        hydro: 'HYDRO',
        naoh: 'NAOH',
        lot: 'LOT'
      },
      validation: {
        saveConditionFailed: 'Save conditions not met. Please check your input values.',
        invalidRecipe: 'Please complete the recipe.',
        noDyestuffAndPercentage: 'Please enter dyestuff and percentage.',
        noDyestuff: 'Please enter dyestuff.',
        noPercentage: 'Please enter percentage.',
        missingPercentage: 'Please enter percentage for the dyestuff.',
        invalidDyestuff: 'Invalid dyestuff.'
      },
      skuWarning: {
        title: 'SKU Missing Warning',
        message: 'The following items are missing SKU and cannot be saved:',
        excludedMessage: 'Items without SKU will be excluded and saved.',
        dyestuff: 'Dyestuff',
        chemical: 'Chemical',
        unknown: 'Unknown'
      },
      windingCardPrint: {
        title: 'Winding Card Print Settings',
        waitingItems: 'Waiting',
        allItemsAssigned: 'All items assigned',
        newGroup: 'New Group',
        groupName: 'Group',
        individual: 'Individual',
        itemsCount: '{{count}} items',
        count: '{{count}}',
        assignInstruction: 'Click items above to assign to groups',
        recipeLabel: 'Recipe',
        singleRecipeInfo: '+ {{count}} single recipe(s) (print directly)'
      }
    },
    result: {
      title: 'Result',
      selectResultMessage: 'Please select the dyeing operation result.',
      selectCheckingMessage: 'Please select the checking result.',
      approval: 'Approval',
      approve: 'Dyeing Confirm',
      colorDefect: 'Color Defect',
      colorDefectHint: 'Modify recipe and re-dye on same work number',
      dyeingAbort: 'Work with New Yarn',
      dyeingAbortHint: 'New work number creation required',
      dyeingAbortConfirmTitle: 'Confirm Dyeing Abort',
      dyeingAbortConfirmMessage: 'Dyeing abort cannot be undone.\nAre you sure you want to abort this dyeing run?',
      dyeingAbortConfirmProceed: 'Abort Dyeing',
      reject: 'Reject',
      add: 'Add',
      new: 'New'
    },
    location: {
      title: 'Storage Location',
      titleRegister: 'Register Storage Location',
      enterLocationMessage: 'Please enter the storage location for completed work.',
      locationLabel: 'Storage Location',
      locationPlaceholder: 'e.g., A1, B2-3, C5',
      locationHelperText: 'Please enter the storage location code.',
      confirmMessage: 'Do you want to store at location "{{location}}"?',
      applyToAllDyeingNo: 'Apply the same location to all dyeing numbers'
    },
    success: {
      machineAssigned: 'Machine assigned successfully',
      operationStarted: 'Operation started successfully',
      resultRecorded: 'Result recorded successfully',
      orderSplit: 'Order split successfully'
    },
    errors: {
      noItemsSelected: 'Please select at least one item',
      noMachineAssigned: 'Please assign machine to all selected items',
      machineAssignFailed: 'Failed to assign machine',
      operationStartFailed: 'Failed to start operation',
      dyeingReadyFailed: 'Failed to mark dyeing as ready.',
      dyeingStartFailed: 'Failed to start dyeing operation.',
      recipeModifyFailed: 'Failed to apply recipe modification.',
      machineAlreadyInUse: 'Machine {{machine}} is already running recipe {{recipe}}.\nPlease wait until the current operation is finished.',
      resultRecordFailed: 'Failed to record result',
      dyeingAbortFailed: 'Failed to abort dyeing',
      orderSplitFailed: 'Failed to split order',
      noRecipeToPrint: 'There are no recipes to print.',
      bulkPrintFailed: 'Failed to print recipes in bulk.',
      processEventFailed: 'Failed to process dyeing event.',
      eventConflict: 'Another operator is processing this recipe. Try again shortly.',
      eventJobTimeout: 'Processing did not finish in time. Refresh the list and check the status.',
      eventApplyFailed: 'Could not finish. Status not changed.',
      inventoryPreflightFailed: 'Insufficient inventory.',
      inventoryFailureLine: '{{itemName}} required {{required}} / available {{available}}',
      inventoryFailureLineWithLocation:
        '{{itemName}} ({{locationName}} #{{locationId}}) required {{required}} / available {{available}}',
      inventoryLocationNotFound: 'Storage location not found: {{locationName}} (#{{locationId}})'
    },
    eventProcessing: 'Processing…',
    status: {
      showCompleted: 'Show completed',
      title: 'Dyeing Status',
      statusTab: 'Status',
      monitoringTab: 'Real-time Monitoring',
      statisticsTab: 'Statistics',
      inventoryTab: 'Inventory',
      inventoryStartDate: 'Start',
      inventoryEndDate: 'End',
      inventoryOpening: 'Opening',
      inventoryClosing: 'Closing',
      inventoryReceipt: 'Receipt',
      inventoryIssue: 'Issue',
      inventoryProduction: 'Production',
      inventoryConsume: 'Consume',
      inventoryTotal: 'Total',
      inventoryDate: 'Date',
      inventoryRangeRequired: 'Select a start and end date.',
      inventoryRangeTooLong: 'The range must be 31 days or less.',
      inventoryRangeInvalid: 'The end date is before the start date.',
      inventorySnapshotPending: 'Month-end snapshot is not ready yet.',
      inventoryStale: 'Retroactive transactions not applied',
      inventoryCloseTz: 'Close timezone {{tz}}',
      inventoryCalendarNote: '{{start}} – {{end}} · Jakarta dates ({{tz}})',
      inventoryMixedUom: 'Sum of quantities across different units.',
      inventoryLoadFailed: 'Failed to load inventory.',
      inventoryLocationMissing: 'Location not found. {{detail}}',
      inventorySnapshotMonth: 'Opening snapshot {{month}}',
      inventorySnapshotAt: 'Snapshot built {{at}}',
      machineQueueTab: 'Machine Queue',
      machineQueueTitle: 'MACHINE QUEUE',
      queueReorder: 'Sort',
      queueReordering: 'Sorting...',
      queueInProgress: 'In Progress',
      queueWaiting: 'Waiting',
      queuePlacement: 'Machine Assigned',
      queueReady: 'Yarn Ready',
      queueDyeing: 'Dyeing',
      queuePostDyeing: 'Drying/Storage',
      queueDelivery: 'Delivery',
      queueReadOnlyHint: 'Only admin and dyeing departments can reorder the queue',
      queueMoveSuccess: 'Queue order updated successfully',
      queueMoveFailed: 'Failed to update queue order',
      queuePollNote: 'Auto-refreshes every 30 seconds',
      queueEmptyMachine: 'No queued work',
      queueActiveMachines: 'Active machines',
      queueDetailItems: 'Item',
      queueDetailDyeingNo: 'Dyeing No',
      queueDetailStyle: 'Style',
      queueDetailColor: 'Color',
      queueDetailCustomer: 'Customer',
      queueDetailDyeingRequestAt: 'Dyeing Request Time',
      queueDetailGiRequestAt: 'GI Request Time',
      queueDetailBoiling: 'Boiling Started',
      queueDetailRunInProgress: 'In Progress',
      queueDetailRunWaiting: 'Waiting',
      queueDetailRecipeModifying: 'Modifying Recipe',
      queueDetailRecipeModified: 'Recipe Updated',
      queueDetailLoadFailed: 'Failed to load detail',
      queueUrgentOverride: 'Urgent override',
      queueUrgentOverrideFailed: 'Failed to update urgent override',
      statisticsComingSoon: 'Statistics chart coming soon',
      expand: 'Expand (+{{count}})',
      collapse: 'Collapse',
      dataRangeNote: '※ Default view shows last 7 days from today. Older dates will be fetched on demand.',
      completedDataNote: '※ Completed history is fetched for the selected date in your browser timezone.',
      shiftLegend: 'Shift',
      excelRangeTitle: 'Excel Download Period',
      shift1: '1 Shift (06:00–14:00)',
      shift2: '2 Shift (14:00–22:00)',
      shift3: '3 Shift (22:00–06:00)',
      pending: 'Pending',
      inProgress: 'In Progress',
      completed: 'Completed',
      idle: 'Idle',
      working: 'Working',
      reject: 'REJECT',
      dyeingAborted: 'DYEING ABORT',
      dyeingAbortedHint: 'Dyeing aborted — new work numbers can be created',
      modifying: 'MODIFYING',
      rackWaiting: 'Rack Waiting',
      rackWaitingLocation: 'Dyeing Confirmed [Location Waiting]',
      dehydrationComplete: 'Dehydration Complete',
      approvalComplete: 'Approval Complete',
      dehydrating: 'Dehydrating',
      swatchWaiting: 'Swatch Delivery Waiting',
      dyeingComplete: 'Dyeing Complete',
      dyeingInProgress: 'Dyeing In Progress',
      workWaiting: 'Waiting',
      rawYarnPreparing: 'Thread Preparing',
      recipeModifying: 'Modify Recipe',
      preparing: 'Preparing',
      preparationNeeded: 'All Conditions Required',
      approvalNeeded: 'Waiting for Result Input',
      dehydrationPending: 'Dehydration Pending',
      locationPending: 'Location Assignment Pending',
      dehydratingShort: 'Dehydration',
      dyeingShort: 'Dyeing',
      selectMachine: 'Please select a machine.',
      waitingForAssignment: 'Waiting for Work Assignment',
      ready: 'Ready',
      dyeingCompleteChecking: 'Dyeing Complete [Checking]',
      approvalCompleteDehydrationWaiting: 'Color Approved [Dehydration Waiting]',
      dehydrationCompleteLocationWaiting: 'Dehydration Complete [Location Waiting]',
      completedWithLocation: 'Completed [{{location}}]',
      vendorChecking: 'Vendor Checking',
      vendorConfirmed: 'Vendor Confirmed',
      vendorRejected: 'Vendor Rejected',
      filter: {
        pending: 'Before Work',
        ready: 'Work Ready',
        dyeing: 'Dyeing',
        approval: 'Result Check',
        dehydration: 'Dehydration',
        location: 'Location Waiting',
        completed: 'Work Complete',
        rejected: 'REJECT'
      }
    },
    actions: {
      assignLocation: 'Assign Location',
      markDyeingReady: 'Dyeing Ready',
      prepareComplete: 'Ready',
      recipeModifyDone: 'Modify Done',
      startDehydration: 'Start Dehydration',
      finishDehydration: 'Finish Dehydration',
      viewResults: 'View Results',
      enterResults: 'Enter Results',
      startOperation: 'Start Operation'
    },
    tooltip: {
      readyCondition: 'Quantity, recipe, and machine must all be set before marking dyeing ready.',
      startCondition: 'Dyeing can be started only after dyeing ready is completed.'
    },
    print: {
      dyeingRequest: 'DYEING REQUEST',
      leader: 'Leader',
      manager: 'Manager',
      itemSize: 'ITEM_SIZE',
      qty: 'QTY',
      dyeNo: 'DYE NO.',
      color: 'COLOR',
      cheese: 'CHEES',
      priority: 'PRIORITY',
      urgent: 'URGENT',
      standard: 'STANDARD',
      data: 'DATA',
      dyeingBT: 'DYEING B/T',
      remark: 'REMARK',
      dyeingLabel: 'DYEING LABEL',
      preparingPrint: 'Preparing Print...',
      printReady: 'Print Ready',
      print: 'Work Order',
      exportToExcel: 'Export to Excel',
      excel: 'Excel',
      printLabels: 'Print Labels',
      label: 'Label',
      printConfirmationCard: 'Print Confirmation Card',
      sheet: 'Sheet',
      printDyeingInstructions: 'Print Dyeing Instructions',
      printConfirmSheet: 'Print Confirmation Sheet',
      selectedItemsCount: '{{count}} items selected',
      noItemsSelected: 'No items selected',
      confirmCard: {
        title: 'Confirmation Card Print Settings',
        selectedItems: 'Selected Items: {{count}}',
        templateSelect: 'Select Template',
        includeBuyerDetail: 'Include Buyer Detail',
        templates: {
          standard: 'STANDARD',
          hansoll: 'HANSOLL',
          seaA: 'SEA-A',
          shinsung: 'SHINSUNG',
          mca: 'MCA',
          hyomyung: 'HYOMYUNG',
          harrysYoungIl: 'Harrys Pack Jaya & Young IL'
        },
        hyomyungOption: {
          title: 'HYOMYUNG Option Select',
          option1: 'Option 1 - Standard',
          option2: 'Option 2 - Compact'
        },
        description: {
          line1: 'Print confirmation card with selected template.',
          line2: 'Up to 10 items can be displayed per page.'
        },
        orderAdjustment: 'Print Order',
        totalItems: 'Total {{count}}',
        orderInstruction: 'Adjust the order by dragging or using arrow buttons.',
        additionalText: {
          placeholder: 'Additional Text',
          options: {
            first: '(1ST)',
            second: '(2ND)',
            third: '(3RD)',
            fourth: '(4TH)',
            fifth: '(5TH)',
            sample: '(SAMPLE)',
            bulk: '(BULK)'
          }
        },
        search: {
          placeholder: 'Dyeing No, Style',
          button: 'Search',
          add: 'Add',
          added: 'Added',
          addAll: 'Add All',
          noResult: 'No results found.',
          resultCount: '{{count}} results'
        }
      }
    },
    modals: {
      createDyeingNumbers: {
        title: 'Create Dyeing Numbers',
        description: 'Create dyeing numbers for selected items.',
        submit: 'Create',
        cheeseBaseValue: 'Standard: {{value}}'
      },
      modifyDyeingNumbers: {
        title: 'Modify Dyeing Request',
        description: 'Modify dyeing request information for selected items.',
        submit: 'Modify',
        cheeseBaseValue: 'Standard: {{value}}'
      }
    },
    filter: {
      showAll: 'All',
      showDyeingOnly: 'Dyeing No O',
      showWithoutDyeing: 'Dyeing No X'
    },
    tableRow: {
      work: '작업',
      number: 'No',
      enterNumber: '번호 입력',
      confirm: '컨펌',
      stock: '재고',
      size: 'SIZE',
      pcs: 'PCS',
      remark: 'REMARK'
    },
    workType: {
      swatch: 'SWATCH',
      repeat: 'REPEAT'
    },
    confirmationType: {
      vendor: 'VENDOR',
      self: 'SELF'
    },
    stockType: {
      na: 'N/A',
      stock_black: 'STOCK BLACK',
      opt: 'OPT',
      opt_white: 'OPT',
      ivory: 'IVORY'
    },

    machineAssigned: 'Machine assigned successfully',
    machineUnassigned: 'Machine unassigned successfully',
    deleteDialog: {
      title: 'Confirm Item Deletion',
      message: 'Are you sure you want to delete this item? This action cannot be undone.'
    }
  },

  winding: {
    title: 'Winding Work',
    qtyEditHint: 'Click to change label quantity',
    tabs: {
      batchRequest: 'Bulk Request',
      requestStatus: 'Request Status',
      status: 'Status',
      inventory: 'Inventory'
    },
    requestTitle: 'Winding Request',
    assignWork: 'Assign Work',
    columns: {
      no: 'No',
      date: 'Date',
      styleNo: 'Style No',
      subOrderId: 'SubOrderID',
      customer: 'CUSTOMER',
      customerName: 'Customer Name',
      productionNo: 'Production No',
      windingId: 'WINDING No',
      windingQty: 'QTY',
      urgent: 'URGENT',
      remark: 'MISC',
      targetDate: 'TARGET DATE',
      dyeingNo: 'DYEING NO',
      windingNo: 'WINDING NO',
      item: 'ITEM',
      size: 'SIZE',
      qty: 'QTY',
      color: 'COLOR',
      cheezRackCode: 'LOC',
      workProcess: 'WORK PROCESS',
      vendor: 'VENDOR',
      dryingRequired: 'DRYING',
      factory: 'FACTORY',
      operation: 'OPERATION',
      planDate: 'PLAN DATE',
      delivery: 'DELIVERY',
      rackCode: 'RACK CODE'
    },
    summary: {
      producedQty: 'Produced QTY'
    },
    operation: {
      pending: 'Pending',
      waiting: 'Waiting',
      processing: 'Processing',
      drying: 'Drying',
      deliveryWaiting: 'Delivery Waiting',
      deliveryProcessing: 'Delivery Processing',
      completed: 'Completed',
      cancelled: 'Cancelled',
      editStartEndTitle: 'WINDING MODIFICATION',
      editStartEndTooltip: 'WINDING MODIFICATION'
    },
    status: {
      waiting: 'Waiting',
      inProgress: 'In Progress',
      drying: 'Drying',
      completed: 'Completed',
      cancelled: 'Cancelled',
      selectLine: 'Select LINE'
    },
    messages: {
      requestSuccess: 'Request processed successfully',
      requestFail: 'Failed to process request',
      noNewItems: 'No new items selected',
      deleteFail: 'Failed to delete winding work',
      selectedItemsCount: '{{count}} items selected',
      noItemsSelected: 'No items selected',
      noPrintableItems: 'No printable items available',
      quantityChangeSuccess: 'Work quantity updated successfully',
      quantityChangeFailed: 'Failed to update work quantity',
      createSuccess: 'Winding work created successfully',
      createFailed: 'Failed to create winding work',
      updateSuccess: 'Winding work updated successfully',
      updateFailed: 'Failed to update winding work',
      editSuccess: 'Winding work edited successfully',
      deleteSuccess: 'Winding work deleted successfully',
      deleteFailed: 'Failed to delete winding work',
      saveSuccess: 'Changes saved successfully',
      saveFailed: 'Failed to save changes',
      noChanges: 'No changes made',
      invalidQuantity: 'Invalid quantity',
      insufficientQuantity: 'Insufficient remaining quantity',
      selectItems: 'Please select items',
      selectItemsToCreate: 'Please select items to create',
      selectItemsToEdit: 'Please select items to edit',
      selectItemsToDelete: 'Please select items to delete',
      selectItemsToPrint: 'Please select items to print',
      confirmDelete: 'Are you sure you want to delete the selected items?',
      confirmSave: 'Are you sure you want to save the changes?',
      cannotDeleteCompleted: 'Cannot delete completed work',
      cannotEditCompleted: 'Cannot edit completed work',
      cannotDeleteInProgress: 'Cannot delete work in progress',
      cannotEditInProgress: 'Cannot edit work in progress',
      batchCreateSuccess: '{{count}} items created successfully',
      batchUpdateSuccess: '{{count}} items updated successfully',
      batchDeleteSuccess: '{{count}} items deleted successfully',
      batchCreateFailed: 'Batch creation failed',
      batchUpdateFailed: 'Batch update failed',
      batchDeleteFailed: 'Batch deletion failed',
      validationError: 'Please check your input values',
      networkError: 'Network error occurred',
      serverError: 'Server error occurred',
      unauthorized: 'Unauthorized access',
      forbidden: 'Access forbidden',
      notFound: 'Requested data not found',
      timeout: 'Request timeout',
      unknownError: 'Unknown error occurred'
    },
    filter: {
      showAll: 'All',
      showWindingOnly: 'Winding No',
      showWithoutWinding: 'Winding No'
    },
    confirmDialog: {
      title: 'Confirm',
      message: 'Are you sure you want to process the request?'
    },
    startCheese: {
      title: 'Start winding',
      cheese: 'Cheese',
      subMaterial: 'Sub-material',
      addCheese: 'Add cheese line',
      addSub: 'Add sub-material line',
      item: 'Item',
      qty: 'Qty',
      available: 'Available',
      balanceButton: 'Check stock',
      deleteLine: 'Delete line',
      balanceFailed: 'Could not read the available quantity.',
      location: 'Location',
      qtyHint: 'Quantity must be greater than 0 with at most 6 decimal places. Lines with an empty quantity are not sent.',
      noSuggestion: 'No suggested cheese. Choose the cheese yourself.',
      remainingCheese: 'Remaining cheese {{remaining}} / Total {{total}}',
      totalQtyLabel: 'Total',
      remainingQtyLabel: 'Remaining',
      status: {
        cheese_weight_missing: 'Cone or yarn weight is missing, so no suggestion is available. Choose the cheese yourself.',
        raw_yarn_missing: 'The dyeing request has no raw yarn. Choose the cheese yourself.',
        dyed_yarn_missing: 'Dyed yarn is not linked. You can choose a cheese, but start may be rejected.',
        item_not_found: 'The semi-finished item was not found. You can choose a cheese, but start may be rejected.'
      },
      errors: {
        cheese_required: 'Enter at least one cheese line.',
        cheese_over_remaining: 'Cheese cannot exceed the remaining quantity ({{remaining}}).',
        consume_lines_required: 'Send at least one consume line.',
        consume_lines_too_many: 'At most 30 consume lines.',
        consume_item_required: 'Select an item.',
        consume_qty_invalid: 'Quantity must be greater than 0 with at most 6 decimal places.',
        consume_category_invalid: 'Only cheese or sub-material can be consumed.',
        consume_location_invalid: 'Cheese location must be 105 or 99.',
        duplicate_consume: 'The same item and location appear on two lines.',
        insufficient_qty: '{{item}} · location {{location}} is greater than the available quantity ({{available}}). The other lines are rolled back too.',
        insufficient_qty_plain: 'Greater than the available quantity. The other lines are rolled back too.',
        invalid_transition: 'The status has already changed. Refreshing the list.',
        dyed_yarn_missing: 'Dyed yarn is not linked.',
        raw_yarn_missing: 'Dyed yarn is not linked.',
        item_not_found: 'Dyed yarn is not linked.',
        inventory_tx_not_found: 'There is no inventory transaction to cancel.'
      }
    },
    fields: {
      searchConditions: 'Search Conditions'
    },
    print: {
      selectedItemsCount: '{{count}} items selected',
      noItemsSelected: 'No items selected',
      workOrderButton: 'Work Order',
      workOrderTitle: 'Winding Request',
      label: 'Label',
      shippingMark: 'Shipping Mark',
      labelDialog: {
        title: 'Label Print',
        description: '{{count}} items selected / Total {{total}} labels',
        subOrderNo: 'SUB ORDER',
        printQty: 'PRINT QTY',
        remark: 'REMARK',
        printButton: 'Print',
        noItems: 'No printable items.'
      },
      workOrderData: {
        selectDate: 'Select Date',
        targetDate: 'Target Date',
        totalQty: 'Total Qty',
        windingLeader: 'Winding Leader'
      },
      workOrder: {
        title: 'Work Order',
        items: 'items',
        totalItems: 'Total {{count}} items',
        targetDate: 'Target Date',
        workDate: 'Work Date',
        planDate: 'Work Date',
        cone: 'cone',
        noTodayWork: 'No work scheduled for today',
        orderInstruction: 'Displayed in work order',
        noDataMessage: 'No work data available for the selected date',
        signature: 'Signature',
        date: 'Date',
        columns: {
          no: 'NO',
          windingNo: 'WINDING NO',
          dyeingNo: 'DYEING NO',
          styleNo: 'STYLE NO',
          vendor: 'VENDOR',
          factory: 'FACTORY',
          item: 'ITEM',
          color: 'COLOR',
          qty: 'QTY',
          size: 'SIZE',
          remark: 'REMARK'
        }
      },
      printTrimCard: 'Print Trim Card',
      trimCard: {
        title: 'Trim Card Print Settings',
        selectedItems: 'Selected Items: {{count}}',
        templateSelect: 'Select Template',
        includeBuyerDetail: 'Include Buyer Detail',
        templates: {
          standard: 'STANDARD',
          saeA: 'SAE-A',
          ubase: 'UBASE',
          shinwon: 'SHINWON',
          hyomyung: 'HYOMYUNG',
          hansoll: 'HANSOLL'
        },
        hyomyungOption: {
          title: 'HYOMYUNG Option Select',
          option1: 'Option 1 - Standard',
          option2: 'Option 2 - Compact'
        },
        description: {
          line1: 'Print trim card with selected template.',
          line2: 'Up to 10 items can be displayed per page.'
        },
        orderAdjustment: 'Print Order Adjustment',
        totalItems: 'Total {{count}} items',
        orderInstruction: 'Adjust the order by dragging or using arrow buttons.',
        additionalText: {
          placeholder: 'Additional Text',
          options: {
            first: '(1ST)',
            second: '(2ND)',
            third: '(3RD)',
            fourth: '(4TH)',
            fifth: '(5TH)',
            sample: '(SAMPLE)',
            bulk: '(BULK)'
          }
        }
      }
    },
    schedule: {
      title: 'Schedule Adjustment',
      adjustButton: 'Schedule Adjustment',
      batchChange: 'Batch Schedule Change',
      workOrder: 'Work List',
      changeDate: 'Change Date',
      noData: 'No Data',
      updateFailed: 'Failed to update schedule',
      dateRangeError: 'Date Range Error',
      dateRangeErrorMessage: 'Selected date is outside the search period.',
      dateRangeDetail: 'Search period: {{startDate}} ~ {{endDate}}',
      dateRangeInstruction: 'Please select a date within the search period.',
      saveFailed: 'Save Failed',
      saveFailedMessage: 'An error occurred while saving schedule changes.',
      saveFailedInstruction: 'Please try again later.',
      itemsSelected: '{{count}} selected'
    }
  },

  shipping: {
    title: 'Shipping Work',
    assignWork: 'Assign Work',
    columns: {
      no: 'No',
      date: 'Date',
      styleNo: 'Style No',
      productionNo: 'Production No',
      shippingId: 'Shipping No',
      shippingQty: 'QTY',
      urgent: 'URGENT',
      remark: 'REMARK',
      targetDate: 'DATE',
      dyeingNo: 'DYEING NO',
      buyer: 'BUYER',
      manager: 'MANAGER',
      vendor: 'VENDOR',
      fileNo: 'FILE NO',
      threadName: 'THREAD NAME',
      color: 'COLOR',
      size: 'SIZE',
      qty: 'QTY',
      shippingTargetDate: 'TARGET DATE',
      truckName: 'TRUCK',
      remark: 'REMARK',
      windingNo: 'WINDING NO',
      timeOfDeparture: 'DEPARTURE',
      timeOfArrival: 'ARRIVAL',
      ctNo: 'C/T NO',
      tracking: 'TRACKING'
    },
    filter: {
      showAll: 'Show All',
      showShippingOnly: 'With Shipping Date',
      showWithoutShipping: 'Without Shipping Date',
      showCompleted: 'Shipping Completed',
      showInProgress: 'Shipping In Progress/Pending'
    },
    fields: {
      searchConditions: 'Search Conditions'
    },
    tracking: {
      completed: 'Delivered',
      in_progress: 'In Delivery',
      not_started: 'Waiting'
    },
    selectedItemsCount: '{{count}} items selected',
    noItemsSelected: 'No items selected',
    printCustomsDocuments: 'Customs Documents',
    printInvoice: 'Delivery Note',
    print: {
      noItemsSelectedForPrint: 'Please select items to print.',
      noValidItemsSelected: 'No valid data found in selected items.',
      downloadSuccess: 'Excel file has been downloaded.',
      downloadFailed: 'File download failed.',
      downloading: 'Downloading file',
      downloadComplete: 'Download complete'
    },
    invoice: {
      printPreview: 'Delivery Note',
      splitBy: 'By',
      splitByCustomer: 'CUSTOMER',
      splitByManager: 'Contact',
      print: 'Print',
      pdf: 'PDF',
      to: 'To',
      documentNumber: 'Document No',
      apply: 'Apply',
      loading: 'Preparing delivery note...'
    },
    dialog: {
      createShippingRequest: {
        title: 'Shipping Request',
        description: 'Create shipping request for {{count}} selected items.',
        submit: 'Create Shipping Request'
      },
      editOperations: {
        title: 'Shipping Operations',
        description: 'Edit operation information for {{count}} selected items.',
        submit: 'Submit'
      },
      bulkSettings: {
        title: 'Bulk Settings',
        targetDate: 'Target Shipping Date',
        truck: 'Truck Name',
        remark: 'Remark',
        departure: 'Departure DateTime',
        arrival: 'Arrival DateTime',
        applyAll: 'Apply to All',
        apply: 'Apply',
        today: 'Today',
        now: 'Now'
      },
      selectedItems: {
        title: 'Selected Items'
      },
      actions: {
        edit: 'Edit',
        save: 'Save',
        cancel: 'Cancel'
      }
    },
    editOperations: 'Edit Operations',
    customs: {
      selectDocument: 'Select Customs Document',
      selectDocumentDescription: 'Please select the customs document format to print.',
      bc27: 'BC 27',
      bc25: 'BC 25',
      bc41: 'BC 41',
      bc30: 'BC 30',
      noItemsSelected: 'Please select items to print customs documents.',
      loadingDocument: 'Preparing customs document...',
      bc27Title: 'BC 27 - Commercial Invoice & Packing List',
      documentNumber: 'Document Number',
      outputFormat: 'Output Format',
      exchangeRate: 'Exchange Rate',
      shipper: 'Shipper/Exportir',
      consignee: 'Consignee',
      notifyParty: 'Notify Party',
      invoiceNo: 'No. & Date of Invoice',
      lcNumber: 'No. & Date of L/C',
      remark: 'Remark',
      portOfLoading: 'Port of Loading',
      finalDestination: 'Final Destination',
      carrier: 'Carrier',
      sailingDate: 'Sailing on or about',
      marksNumber: 'Marks and Number of PKGS',
      itemCode: 'Item Code',
      hsCode: 'HS Code',
      style: 'Style',
      description: 'Description of goods',
      netKg: 'Net Kg',
      qty: 'Qty',
      totalPrice: 'Total Price',
      rate: 'Rate',
      package: 'Package',
      amount: 'Amount (Rp)',
      doubleClickToEdit: 'Double-click to edit',
      npwp16: 'NPWP 16',
      nitku: 'NITKU',
      npwpPlaceholder: '00.000.000.0-000.000',
      nitkuPlaceholder: '0000000000000000000000',
      addressPlaceholder: 'Address',
      cityPlaceholder: 'City',
      address1: 'Address 1',
      address2: 'Address 2',
      address1Placeholder: 'Address 1',
      address2Placeholder: 'Address 2',
      loadingCustomsDocuments: 'Preparing customs document data...',
      vendorInfoWarning: 'Please check Address, NPWP, and NITKU in Master Data > Company > Company Registration.'
    }
  },

  dashboard: {
    activeOrders: 'Active Orders',
    productionRate: 'Production Rate',
    pendingShipments: 'Pending Shipments',
    averageProcessTime: 'Process Time',
    thisMonthOrders: 'This Month Orders',
    lastMonthOrders: 'Last Month Orders',
    thisMonthShipments: 'This Month Shipments',
    lastMonthShipments: 'Last Month Shipments',
    recentProduction: 'Recent Production',
    orderStatus: 'Order Status',
    inbound: 'Inbound',
    outbound: 'Outbound',
    vsLastWeek: 'vs Last Week',
    vsTarget: 'vs Target',
    vsYesterday: 'vs Yesterday',
    vsLastMonth: 'vs Last Month',
    vsLastYear: 'vs Last Year',
    currentMonth: 'Current Month',
    date: 'Date',
    noProductionData: 'No production data available',
    production: {
      winding: 'Winding',
      windingStatus: 'Winding Production Status',
      cheese: 'Cheese',
      batch: 'LOT',
      batch_s1: 'LOT 1S (06–14)',
      batch_s2: 'LOT 2S (14–22)',
      batch_s3: 'LOT 3S (22–06)',
      dyeing: 'Dyeing Production Status',
      dyeingDayBasis: 'Dyeing operating day: {{timezone}} from {{hour}}:00'
    }
  },

  login: {
    welcome: 'Welcome',
    username: 'Username',
    password: 'Password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    login: 'Login',
    noAccount: 'No account?',
    signup: 'Sign up',
    loading: 'Logging in...',
    success: 'Login successful',
    validation: {
      required: 'Username and password required.',
      usernameRequired: 'Please enter your username.',
      passwordRequired: 'Please enter your password.'
    },
    error: {
      notFound: 'Account not found.\nCheck username.',
      invalidPassword: 'Invalid password.\nTry again.',
      waitingApproval: 'Waiting for approval.',
      blocked: 'Account blocked.\nContact admin.',
      network: 'Network error.\nCheck connection.',
      unknown: 'Unknown error.\nTry again.',
      userFetchFailed: 'An error occurred while fetching user information.',
      userUpdateFailed: 'An error occurred while updating user information.',
      languageUpdateFailed: 'An error occurred while updating language settings.',
      logoutFailed: 'An error occurred during logout.'
    }
  },

  signup: {
    title: 'Sign Up',
    department: 'Department',
    region: 'Region',
    fullName: 'Full Name',
    userId: 'User ID',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    submit: 'Submit',
    submitting: 'Submitting...',
    cancel: 'Cancel',
    loading: 'Creating account...',
    fields: {
      userId: 'User ID',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      fullName: 'Full Name',
      department: 'Department',
      region: 'Region',
      initialStr: 'Initial',
      initialStrHelp: 'First alphabet of your English name. Only one or two letters allowed.'
    },
    regions: {
      korea: 'Korea',
      vietnam: 'Vietnam',
      indonesia: 'Indonesia'
    },
    messages: {
      registerSuccess: 'Account created successfully.\nWaiting for admin approval.'
    },
    validation: {
      required: 'This field is required',
      fullName: {
        invalid: 'Only letters and spaces allowed'
      },
      userId: {
        tooShort: 'User ID must be at least 6 characters',
        invalid: 'User ID can only contain letters and numbers'
      },
      password: {
        tooShort: 'Password must be at least 6 characters',
        invalid: 'Password must include uppercase letters, lowercase letters, numbers, and special characters'
      },
      passwordMismatch: 'Passwords do not match'
    },
    error: {
      duplicate: 'User ID already exists.\nPlease try another.',
      network: 'Network error occurred.\nPlease try again.',
      unknown: 'Unknown error occurred.\nPlease try again.',
      userIdExists: 'User ID already exists.',
      initialStrExists: 'Initial string already exists.',
      passwordInvalid: 'Password is invalid.',
      requiredFields: 'Please fill in all required fields.',
      passwordMismatch: 'Passwords do not match.',
      passwordLength: 'Password must be at least 6 characters.',
      userIdRequired: 'Please enter your user ID.',
      passwordRequired: 'Please enter your password.',
      confirmPasswordRequired: 'Please confirm your password.',
      fullNameRequired: 'Please enter your full name.',
      departmentRequired: 'Please select a department.',
      regionRequired: 'Please select a region.',
      initialStrRequired: 'Please enter the initial.',
      server: 'A server error occurred. Please try again.'
    },
    departments: {
      marketing: 'Marketing',
      dyeing: 'Dyeing',
      production: 'Production',
      'qc/qa': 'QC/QA',
      admin: 'Admin'
    }
  },

  companies: {
    tabs: {
      company: 'Company',
      manager: 'Manager',
      factory: 'Factory',
      map: 'Factory Map'
    },
    companyInfo: 'Company Information',
    fields: {
      partner_code: 'Company Code',
      companyName: 'Company Name',
      businessNumber: 'Business Number',
      representative: 'Representative',
      businessType: 'Business Type',
      businessCategory: 'Business Category',
      postalCode: 'Postal Code',
      baseAddress: 'Base Address',
      detailAddress: 'Detail Address',
      address: 'Address',
      extraInfo: 'Extra Info',
      extraInfoKey: 'Key',
      extraInfoValue: 'Value',
      addExtraInfo: 'Add Extra Info',
      created_at: 'Registration Time',
      created_by: 'Registrant',
      searchByNameOrCode: 'Search by company code or name',
      searchByPartnerCodeOrCompanyName: 'Search by Partner Code or Company Name'
    },
    list: {
      title: 'Company List'
    },
    search: 'Search',
    addressSearch: 'Search Address',
    searchPlaceholder: 'Search by company name or business number',
    add: {
      title: 'Register Company',
      confirmMessage: 'Would you like to register a new company?',
      success: 'Company has been successfully registered.'
    },
    edit: {
      title: 'Edit Company',
      success: 'Company information has been updated.',
      confirmMessage: 'Would you like to update this company?'
    },
    delete: {
      title: 'Delete Company',
      confirmMessage: 'Are you sure you want to delete {{name}}?'
    },
    changes: {
      before: 'Before',
      after: 'After'
    }
  },

  buyers: {
    title: 'Buyer Management',
    form: {
      title: 'Buyer Information'
    },
    list: {
      title: 'Buyer List'
    },
    fields: {
      buyerCode: 'Buyer Code',
      buyerName: 'Buyer Name',
      buyerGroup: 'Group',
      category: 'Category',
      remark: 'Remark'
    },
    validation: {
      required: 'This field is required',
      duplicateCategoryBuyer: 'Buyer with the same category and name already exists'
    },
    add: {
      title: 'Register Buyer',
      confirmMessage: 'Would you like to register a new buyer?',
      success: 'Buyer has been successfully registered.'
    },
    edit: {
      title: 'Edit Buyer',
      confirmMessage: 'Would you like to update this buyer?',
      success: 'Buyer has been successfully updated.'
    },
    delete: {
      title: 'Delete Buyer',
      confirmMessage: 'Are you sure you want to delete {{name}}?'
    },
    searchPlaceholder: 'Search by buyer code or buyer name',
    error: {
      duplicateCategoryBuyer: 'Buyer with the same category and name already exists'
    }
  },

  managers: {
    form: {
      title: 'Manager Information'
    },
    fields: {
      name: 'Name',
      partnerId: 'Company',
      telephone: 'Telephone',
      mobile: 'Mobile',
      fax: 'Fax',
      email: 'Email',
      partnerName: 'Company Name'
    },
    list: {
      title: 'Manager List'
    },
    add: {
      title: 'Register Manager',
      confirmMessage: 'Would you like to register a new manager?',
      success: 'Manager has been successfully registered.'
    },
    edit: {
      title: 'Edit Manager',
      success: 'Manager information has been updated.',
      confirmMessage: 'Would you like to update this manager?'
    },
    delete: {
      title: 'Delete Manager',
      confirmMessage: 'Are you sure you want to delete {{name}}?'
    },
    searchPlaceholder: 'Search by manager name or company name',
    validation: {
      selectCompany: 'Please select a company'
    },
    error: {
      title: "Error",
      save: "Failed to save.",
      duplicateManager: "Manager name already exists for this company."
    }
  },

  factories: {
    form: {
      title: 'Factory Information'
    },
    list: {
      title: 'Factory List'
    },
    fields: {
      partner: 'Company',
      name: 'Factory Name',
      shippingMark: 'Shipping Mark',
      region: 'Region',
      address: 'Address',
      address1: 'Address 1',
      address2: 'Address 2',
      city: 'City',
      state: 'State/Province',
      postcode: 'Postcode',
      country: 'Country',
      countryCode: 'Country Code',
      taxId: 'TIN',
      customsId: 'EIN',
      extraInfo: 'Extra Info',
      extraInfoKey: 'Key',
      extraInfoValue: 'Value',
      addPartner: 'Add Company',
      addExtraInfo: 'Add Extra Info'
    },
    validation: {
      selectCompany: 'Please select a company',
      required: 'This field is required'
    },
    add: {
      title: 'Register Factory',
      confirmMessage: 'Would you like to register a new factory?',
      success: 'Factory has been successfully registered.'
    },
    edit: {
      title: 'Edit Factory',
      confirmMessage: 'Would you like to update this factory?',
      success: 'Factory has been successfully updated.'
    },
    delete: {
      title: 'Delete Factory',
      confirmMessage: 'Are you sure you want to delete {{name}}?'
    },
    searchPlaceholder: 'Search by company or factory name'
  },

  admin: {
    registration: {
      list: 'Registration List',
      userId: 'User ID',
      name: 'Name',
      department: 'Department',
      region: 'Region',
      date: 'Date',
      actions: 'Actions',
      status: {
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
        all: 'All Status'
      },
      approve: 'Approve',
      reject: 'Reject',
      add: 'Add',
      addNew: 'Add New',
      addSuccess: 'User has been added successfully.',
      allDepartments: 'All Departments',
      status_name: 'Status',
      approveSuccess: 'Registration has been approved.',
      approveFailed: 'Registration approval failed.',
      rejectSuccess: 'Registration has been rejected.',
      rejectFailed: 'Registration rejection failed.'
    },
    passwordReset: {
      list: 'Password Reset List',
      userId: 'User ID',
      name: 'Name',
      department: 'Department',
      region: 'Region',
      lastReset: 'Last Reset',
      resetButton: 'Reset Password',
      confirmReset: 'Are you sure you want to reset the password?',
      action: 'Action'
    },
    accessLogs: {
      list: 'Access Logs',
      userId: 'User ID',
      name: 'Name',
      department: 'Department',
      accessTime: 'Access Time',
      ipAddress: 'IP Address',
      action: 'Action',
      status: 'Status',
      startDate: 'Start Date',
      endDate: 'End Date',
      allDepartments: 'All Departments',
      departments: {
        all: 'All Departments',
        production: 'Production',
        marketing: 'Marketing',
        admin: 'Admin'
      },
      actions: {
        login: 'Login',
        logout: 'Logout',
        all: 'All Actions'
      },
      status: {
        name: 'Status',
        success: 'Success',
        failed: 'Failed'
      },
      region: 'Region'
    },
    message: {
      title: 'Message Title',
      content: 'Message Content',
      send: 'Send Message',
      selectedUsers: 'Selected Users',
      user: 'User',
      selectUsers: 'Select Users',
      department: 'Department',
      region: 'Region',
      allDepartments: 'All Departments',
      departments: {
        production: 'Production',
        marketing: 'Marketing',
        admin: 'Admin'
      }
    },
    threads: {
      tabs: {
        item: 'Item Registration',
        weight: 'Weight Registration'
      },
      list: {
        title: 'Item List'
      },
      form: {
        title: 'Item Information'
      },
      edit: {
        title: 'Edit Item',
        confirmMessage: 'Would you like to update this item?',
        success: 'Item has been successfully updated.'
      },
      fields: {
        threadName: 'Item Name',
        specification: 'Type Thread',
        division: 'Division',
        yarn_type: 'Yarn Type',
        tex: 'TEX',
        ne: 'NE',
        denier: 'DENIER',
        thread_luster_type: 'Thread Luster Type',
        threadLusterType: 'Thread Luster Type',
        recycleCode: 'Eco-friendly Code',
        weight: 'Weight',
        unit: 'Unit'
      },
      searchPlaceholder: 'Search by item name',
      validation: {
        required: 'This field is required',
        invalidNumber: 'Please enter a valid number',
        duplicateSpecification: 'Item specification already exists',
        duplicateThread: 'Item with the same name and specification already exists',
        unit: 'Please enter a unit',
        selectItem: 'Please select an item'
      },
      add: {
        title: 'Register Item',
        confirmMessage: 'Would you like to register a new item?',
        success: 'Item has been successfully registered.'
      },
      delete: {
        title: 'Delete Item',
        confirmMessage: 'Are you sure you want to delete {{name}}?'
      }
    },
    prices: {
      list: {
        title: 'Price List',
        totalCount: 'Total price items : {{count}}'
      },
      columns: {
        no: 'NO',
        customer: 'CUSTOMER',
        item: 'ITEM',
        size: 'SIZE',
        currency: 'CURRENCY',
        price: 'PRICE',
        spec: 'SPEC',
        regDate: 'REG DATE',
        action: 'ACTION'
      },
      picker: {
        title: 'Select a result',
        type: 'TYPE',
        name: 'NAME',
        customer: 'CUSTOMER',
        item: 'ITEM'
      },
      form: {
        title: 'Price Information'
      },
      fields: {
        companyName: 'Company',
        itemName: 'Item',
        size: 'Size(M)',
        currency: 'Currency',
        price: 'Price',
        searchByNameOrCode: 'Search by company or item name',
        duplicate: 'This price is already registered.'
      },
      validation: {
        required: 'This field is required'
      },
      add: {
        title: 'Register Price',
        confirmMessage: 'Would you like to register a new price?',
        success: 'Price has been successfully registered.'
      },
      edit: {
        title: 'Edit Price',
        confirmMessage: 'Would you like to update this price?',
        success: 'Price has been successfully updated.'
      },
      delete: {
        title: 'Delete Price',
        confirmMessage: 'Are you sure you want to delete this price?'
      },
      searchPlaceholder: 'Search by company or item name'
    },
    sizes: {
      list: {
        title: 'Size List'
      },
      form: {
        title: 'Size Information'
      },
      fields: {
        size: 'Size(M)'
      },
      validation: {
        required: 'This field is required',
        invalidNumber: 'Please enter a valid number',
        duplicate: 'This size already exists.',
        selectSize: 'Please select a size'
      },
      add: {
        title: 'Register Size',
        confirmMessage: 'Would you like to register a new size?',
        success: 'Size has been successfully registered.'
      },
      edit: {
        title: 'Edit Size',
        confirmMessage: 'Would you like to update this size?',
        success: 'Size has been successfully updated.'
      },
      delete: {
        title: 'Delete Size',
        confirmMessage: 'Are you sure you want to delete {{size}}?'
      },
      searchPlaceholder: 'Search by size',
      search: 'Search Size'
    },
    weights: {
      list: {
        title: 'Weight List'
      },
      form: {
        title: 'Weight Information'
      },
      fields: {
        threadName: 'Item Name',
        size: 'Size(M)',
        netWeight: 'Net Weight (N/W)',
        grossWeight: 'Gross Weight (G/W)',
        ctQuantity: 'Quantity (C/T)',
        remark: 'Remark'
      },
      validation: {
        required: 'This field is required',
        invalidNumber: 'Please enter a valid number',
        duplicate: 'This weight configuration already exists.'
      },
      add: {
        title: 'Register Weight',
        confirmMessage: 'Would you like to register a new weight?',
        success: 'Weight has been successfully registered.'
      },
      edit: {
        title: 'Edit Weight',
        confirmMessage: 'Would you like to update this weight?',
        success: 'Weight has been successfully updated.'
      },
      delete: {
        title: 'Delete Weight',
        confirmMessage: 'Are you sure you want to delete this weight?'
      },
      searchPlaceholder: 'Search by item name',
      search: 'Search Weight'
    },
    yarn: {
      list: 'Yarn List',
      code: 'Yarn Code',
      type: 'Type',
      count: 'Count',
      twist: 'Twist',
      supplier: 'Supplier',
      lotNumber: 'Lot Number',
      quantity: 'Quantity',
      location: 'Location',
      status: {
        inStock: 'In Stock',
        lowStock: 'Low Stock',
        outOfStock: 'Out of Stock',
        all: 'All Status'
      },
      add: 'Add Yarn',
      addNew: 'Add New Yarn',
      allTypes: 'All Types',
      type: {
        cotton: 'Cotton',
        polyester: 'Polyester',
        blend: 'Blend'
      },
      location: {
        warehouseA: 'Warehouse A',
        warehouseB: 'Warehouse B',
        production: 'Production'
      },
      showHistory: 'Show History',
      history: 'Movement History'
    },
    dye: {
      list: 'Dye List',
      code: 'Dye Code',
      name: 'Dye Name',
      type: 'Type',
      manufacturer: 'Manufacturer',
      color: 'Color',
      lotNumber: 'Lot Number',
      quantity: 'Quantity',
      location: 'Location',
      expiryDate: 'Expiry Date',
      status: {
        inStock: 'In Stock',
        lowStock: 'Low Stock',
        outOfStock: 'Out of Stock',
        expired: 'Expired',
        nearExpiry: 'Near Expiry',
        all: 'All Status'
      },
      add: 'Add Dye',
      addNew: 'Add New Dye',
      allTypes: 'All Types',
      type: {
        reactive: 'Reactive',
        disperse: 'Disperse',
        acid: 'Acid'
      },
      color: {
        blue: 'Blue',
        red: 'Red',
        yellow: 'Yellow'
      },
      location: {
        storageA: 'Storage A',
        storageB: 'Storage B',
        production: 'Production'
      },
      showHistory: 'Show History',
      history: 'Movement History',
      expiredWarning: 'This item has expired',
      sampleName: 'Sample Dye'
    },
    inventory: {
      list: 'Inventory List',
      code: 'Item Code',
      name: 'Item Name',
      type: 'Type',
      category: 'Category',
      quantity: 'Quantity',
      location: 'Location',
      minStock: 'Min Stock',
      maxStock: 'Max Stock',
      lastMovement: 'Last Movement',
      stockRange: 'Stock Range',
      status: {
        inStock: 'In Stock',
        lowStock: 'Low Stock',
        overStock: 'Over Stock',
        all: 'All Status'
      },
      add: 'Add Inventory',
      addNew: 'Add New Inventory',
      allTypes: 'All Types',
      allLocations: 'All Locations',
      type: {
        yarn: 'Yarn',
        dye: 'Dye',
        chemical: 'Chemical',
        packaging: 'Packaging'
      },
      category: {
        rawMaterial: 'Raw Material',
        finishedGood: 'Finished Good',
        packaging: 'Packaging'
      },
      location: {
        warehouseA: 'Warehouse A',
        warehouseB: 'Warehouse B',
        production: 'Production'
      },
      recordMovement: 'Record Movement',
      sampleItem: 'Sample Item'
    },
    bi: {
      title: 'BI',
      startDate: 'Start Date',
      endDate: 'End Date',
      customer: 'CUSTOMER',
      manager: 'Contact',
      buyer: 'BUYER',
      search: 'Search',
      loading: 'Please wait...',
      orderDate: 'Order Date',
      vendorName: 'Company',
      itemName: 'Item',
      size: 'Size',
      color: 'Color',
      qty: 'QTY',
      price: 'Unit Price',
      amount: 'Amount',
      total: 'TOTAL',
      itemAggregationTitle: 'Item Aggregation by Period',
      noData: 'No data found',
      searchGuide: 'Please search to view data',
      error: 'Error',
      dateError: 'End date cannot be earlier than start date.'
    }
  },

  error: {
    fetch: 'Failed to fetch data',
    network: 'Network error occurred',
    unknown: 'Unknown error occurred',
    title: 'Error',
    duplicate: 'Company already exists',
    duplicateFactory: 'Factory already exists',
    duplicateManager: 'Manager already exists',
    duplicateDivisionSeason: 'A buyer with the same division and season already exists',
    save: 'Failed to save data',
    unauthorized: 'Login token has expired.\nPlease login again.',
    noChanges: 'No changes to update',
    sessionExpired: 'Your session has expired. Please login again.'
  },

  initialStr: {
    label: 'Unique Dyeing Code',
    placeholder: 'Enter 1-2 characters (a-z, A-Z)',
    required: 'Unique dyeing code is required',
    invalid: 'Only 1-2 English characters allowed',
    alreadyExists: 'This unique code is already in use',
    validationFailed: 'Failed to validate unique code',
    notVerified: 'Please verify the uniqueness of the dyeing code',
    verifying: 'Verifying unique code...'
  },

  validation: {
    required: 'This field is required',
    selectCompany: 'Please select a company'
  },
  userInfoDialog: {
    title: 'User Information',
    basicInfo: 'Basic Information',
    id: 'ID (Read Only)',
    name: 'Name',
    department: 'Department (Read Only)',
    region: 'Region',
    password: 'Password',
    editableInfo: 'Editable Information',
    passwordChange: 'Password Change',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    currentPassword: 'Current Password',
    confirmCurrentPassword: 'Confirm Current Password',
    passwordError: 'Password does not match',
    passwordSuccess: 'Password has been successfully changed',
  },

  invoice: {
    title: 'Invoice Issuance',
    selectedItems: 'Selected Items',
    issueButton: 'Issue Invoice',
    debitNoteButton: 'Issue DEBIT NOTE',
    debitNote: {
      errorTitle: 'Cannot Issue',
      differentCustomers: 'Please select from the same customer only',
      currentlySelectedCustomers: 'Currently selected customers',
      missingPacking: 'Please select only shipped items.',
      itemsWithoutPackingDate: 'Items without PACKING date'
    },
    hideInvoicedToggle: {
      tooltipOff: 'Show all rows',
      tooltipOn:
        'Hide fully invoiced rows; rows where invoiced qty sum is still below order qty stay visible'
    },
    warning: 'Warning',
    selectItems: 'Please select items to issue',
    differentVendors: 'Selected items have different vendors. Please select items from the same vendor.',
    differentCurrencies: 'Selected items have different currencies. Please select items with the same currency.',
    existingInvoiceWarning: '{{existingCount}}/{{totalCount}} selected items already have invoices issued. Do you want to continue?',
    success: 'Success',
    issuanceSuccess: 'Invoice has been successfully issued',
    partialIssuanceSuccess: 'invoices have been successfully issued',
    issuanceError: 'Failed to issue invoice',
    startDate: 'Start Date',
    endDate: 'End Date',
    customerName: 'Customer Name',
    managerName: 'Manager Name',
    invoiceNo: 'Invoice NO',
    invoiceDate: 'Invoice Date',
    dueDate: 'Due Date',
    currency: 'Currency',
    amount: 'Amount',
    vatAmount: 'VAT',
    vatAmount2: 'VAT2',
    totalAmount: 'Total Amount',
    status: 'Status',
    updateStatus: 'Update Status',
    statusUpdateTitle: 'Invoice Status Update',
    newStatus: 'New Status',
    selectedInvoices: 'Selected Invoices ({{count}})',
    noData: 'No data found',
    error: {
      startDateRequired: 'Start date is required',
      selectItemsForStatusUpdate: 'Please select items to update status',
      selectItemsForPrint: 'Please select invoices to print',
      statusUpdateFailed: 'Failed to update status',
      noDataToExport: 'No data to export',
      exportFailed: 'Export failed',
      noItemSelected: 'No items selected'
    },
    print: {
      title: 'Invoice Print',
      preview: 'Invoice Preview',
      columnSettings: 'Print Column Settings'
    },
    itemDetails: 'Item Details',
    bankInfo: 'Bank Information',
    success: {
      statusUpdate: '{{success}} invoice statuses have been successfully updated. (Failed: {{fail}})',
      exportCompleted: 'Data has been successfully exported'
    },
    statusOptions: {
      issued: 'Issued',
      pending: 'Pending',
      cancelled: 'Cancelled',
      paid: 'Paid',
      partial_paid: 'Partial Paid',
      partial: 'Partial Paid',
      canceled: 'Canceled',
      completed: 'Completed',
      overdue: 'Overdue',
      canceled: 'Canceled',
      unpaid: 'Unpaid'
    },
    vat: {
      taxFree: 'Tax Free',
      BC21: 'BC21',
      BC45: 'BC45'
    },
    columns: {
      no: 'NO',
      giReqNo: 'GI REQ NO',
      giReqLineId: 'GI REQ LINE ID',
      customer: 'CUSTOMER',
      subOrderId: 'SubOrderID',
      buyer: 'BUYER',
      style: 'STYLE',
      file: 'FILE',
      delivery: 'DELIVERY',
      manager: 'MANAGER',
      item: 'ITEM',
      size: 'SIZE',
      dyeingNo: 'DYEING NO',
      orderQty: 'ORDER QTY',
      giReq: 'GI REQ',
      packing: 'PACKING',
      giPost: 'GI POST',
      priceSum: 'PRICE SUM',
      invoiceNoCol: 'INVOICE NO',
      status: 'STATUS',
      currency: 'CURRENCY',
      mainOrderId: 'Main Order ID',
      orderReceivedDate: 'Order Received Date',
      deliveryDate: 'Delivery Date',
      vendorName: 'Vendor Name',
      managerName: 'Manager Name',
      threadName: 'Thread Name',
      sizeName: 'Size',
      color: 'COLOR',
      giHistory: 'DELIVERY DATE',
      qtyDelivered: 'Delivered Qty',
      price: 'PRICE',
      priceCurrency: 'Currency',
      amount: 'Amount',
      existingInvoiceNo: 'Existing Invoice No',
      existingInvoiceStatus: 'Existing Invoice Status',
      payment: 'Payment',
      paymentStatus: 'Payment Status',
      styleNo: 'Style No',
      fileNo: 'File No',
      factory: 'Factory',
      sign: 'Sign'
    },
    fields: {
      searchConditions: 'Search Conditions',
      deliveryId: 'DELIVERY ID'
    },
    minAmount: 'Min Amount',
    maxAmount: 'Max Amount',
    paymentStatus: 'Payment Status',
    dialog: {
      title: 'Confirm Invoice Issuance',
      description: 'Are you sure you want to issue invoices for the selected items?',
      selectedCount: 'Selected Items',
      totalAmount: 'TOTAL',
      totalQuantity: 'QTY TOTAL',
      vendorName: 'Vendor Name',
      summary: 'Summary',
      itemCount: 'Item Count',
      currencyAmount: 'TOTAL',
      details: 'Details',
      invoiceGroup: 'Invoice Group',
      vatSelection: 'VAT Selection',
      vatType: 'VAT Type',
      warning: 'Invoices cannot be modified after issuance. Please review carefully.',
      confirm: 'Confirm Issuance',
      bulkApplyDeliveryDate: 'Apply to selected rows',
      confirmTitle: 'Confirm Invoice Issuance',
      confirmMessage: 'Issued invoices cannot be cancelled.\nDo you want to proceed?',
      confirmYes: 'Yes',
      confirmNo: 'No'
    },
    row: {
      issued: 'Issued'
    }
  },
  master: {
    machine: {
      list: {
        title: 'Machine List'
      },
      form: {
        title: 'Machine Information'
      },
      fields: {
        machineNo: 'Machine No.',
        machineName: 'Machine Name',
        category: 'Category',
        manufacturedDate: 'Manufactured Date',
        installedDate: 'Installed Date',
        manufacturer: 'Manufacturer',
        price: 'Price',
        currency: 'Currency',
        polyMin: 'Poly Min',
        polyMax: 'Poly Max',
        nylonMin: 'Nylon Min',
        nylonMax: 'Nylon Max',
        cheeseRange: 'Cheese Qty (P/N)',
        yarnType: 'Dedicated Yarn',
        remark: 'Remark',
        isActive: 'Active'
      },
      yarnType: {
        poly: 'Poly only',
        nylon: 'Nylon only',
        common: 'Common'
      },
      active: 'Active',
      inactive: 'Inactive',
      add: {
        title: 'Register Machine',
        confirmMessage: 'Register the entered machine information?',
        success: 'Machine has been registered.'
      },
      edit: {
        title: 'Edit Machine',
        confirmMessage: 'Update the machine information?',
        success: 'Machine information has been updated.'
      },
      delete: {
        title: 'Delete Machine',
        confirmMessage: 'Are you sure you want to delete {{name}}?'
      },
      validation: {
        price: 'Enter a number with up to 2 decimal places.',
        polyMinMax: 'Poly max must be greater than or equal to min.',
        nylonMinMax: 'Nylon max must be greater than or equal to min.'
      },
      error: {
        duplicateMachineNo: 'Machine number already exists.',
        invalidCurrency: 'Invalid currency.',
        invalidYarnType: 'Invalid dedicated yarn type.',
        minMax: 'Max quantity must be greater than or equal to min quantity.'
      },
      searchPlaceholder: 'Search by machine no./name/manufacturer'
    },
    uom: {
      tabs: {
        registration: 'UOM Registration',
        conversion: 'UOM Conversion Registration'
      },
      list: {
        title: 'UOM List'
      },
      form: {
        title: 'UOM Information'
      },
      edit: {
        title: 'Edit UOM',
        confirmMessage: 'Would you like to update this UOM?',
        success: 'UOM has been successfully updated.'
      },
      fields: {
        code: 'Code',
        name: 'Name'
      },
      searchPlaceholder: 'Search by code or name',
      validation: {
        required: 'This field is required',
        duplicateUom: 'UOM code already exists'
      },
      add: {
        title: 'Register UOM',
        confirmMessage: 'Would you like to register a new UOM?',
        success: 'UOM has been successfully registered.'
      },
      delete: {
        title: 'Delete UOM',
        confirmMessage: 'Are you sure you want to delete {{name}}?'
      },
      conversion: {
        title: 'UOM Conversion Registration',
        list: {
          title: 'UOM Conversion List'
        },
        form: {
          title: 'UOM Conversion Information'
        },
        fields: {
          fromUom: 'From UOM',
          toUom: 'To UOM',
          factor: 'Conversion Factor'
        },
        searchPlaceholder: 'Search by UOM code, name or factor',
        validation: {
          required: 'This field is required',
          sameUom: 'From UOM and To UOM cannot be the same',
          duplicateConversion: 'This conversion already exists',
          invalidFactor: 'Please enter a valid conversion factor'
        },
        add: {
          title: 'Register UOM Conversion',
          confirmMessage: 'Would you like to register a new UOM conversion?',
          success: 'UOM conversion has been successfully registered.'
        },
        delete: {
          title: 'Delete UOM Conversion',
          confirmMessage: 'Are you sure you want to delete {{name}}?'
        }
      }
    },
    location: {
      list: {
        title: 'Location List'
      },
      form: {
        title: 'Location Information'
      },
      edit: {
        title: 'Edit Location',
        confirmMessage: 'Would you like to update this location?',
        success: 'Location has been successfully updated.'
      },
      fields: {
        siteCode: 'Site Code',
        warehouse: 'Warehouse',
        binCode: 'Bin Code',
        type: 'Type',
        isActive: 'Active'
      },
      types: {
        warehouse: 'Warehouse',
        site: 'Site',
        bin: 'Bin'
      },
      searchPlaceholder: 'Search by site code, warehouse, bin code or type',
      validation: {
        required: 'This field is required',
        duplicateLocation: 'This location already exists'
      },
      add: {
        title: 'Register Location',
        confirmMessage: 'Would you like to register a new location?',
        success: 'Location has been successfully registered.'
      },
      delete: {
        title: 'Delete Location',
        confirmMessage: 'Are you sure you want to delete {{name}}?'
      },
      downloadLayout: 'Warehouse Layout'
    },
    supplier: {
      list: {
        title: 'Supplier List'
      },
      form: {
        title: 'Supplier Information'
      },
      edit: {
        title: 'Edit Supplier',
        confirmMessage: 'Would you like to update this supplier?',
        success: 'Supplier has been successfully updated.'
      },
      fields: {
        partnerName: 'Supplier Name',
        partnerGroup: 'Supplier Group',
        specification: 'Remarks',
        bizRegNo: 'Business Registration Number',
        postcode: 'Postcode',
        address1: 'Address 1',
        address2: 'Address 2',
        region: 'Region'
      },
      groups: {
        supplier: 'Supplier'
      },
      regions: {
        korea: 'Korea',
        indonesia: 'Indonesia',
        china: 'China',
        usa: 'USA',
        other: 'Other'
      },
      searchPlaceholder: 'Search by supplier name, remarks, business registration number or address',
      validation: {
        required: 'This field is required',
        duplicateSupplier: 'This supplier already exists'
      },
      add: {
        title: 'Register Supplier',
        confirmMessage: 'Would you like to register a new supplier?',
        success: 'Supplier has been successfully registered.'
      },
      delete: {
        title: 'Delete Supplier',
        confirmMessage: 'Are you sure you want to delete {{name}}?'
      }
    },
    itemTaxon: {
      title: 'Item Taxonomy',
      selectCategory: 'Select Category',
      noData: 'No data to display',
      hasAttributes: 'Has attributes',
      attributes: 'Attributes',
      levels: {
        category: 'Category',
        type: 'Type',
        spec: 'Spec'
      }
    },
    item: {
      fields: {
        sku: 'SKU',
        name: 'Item Name',
        category: 'Category',
        baseUom: 'Base UOM',
        type: 'Type',
        spec: 'Spec',
        isDutyFree: 'Duty Free',
        hsCode: 'HS Code',
        attributes: 'Attributes'
      },
      selectCategory: 'Select Category',
      name: 'Item Name',
      attributes: {
        keyPlaceholder: 'Key',
        valuePlaceholder: 'Value',
        add: 'Add Attribute'
      },
      list: {
        title: 'Item Information'
      },
      form: {
        title: 'Register Item'
      },
      add: {
        title: 'Register Item',
        confirmMessage: 'Would you like to register a new item?',
        success: 'Item has been successfully registered.'
      },
      edit: {
        title: 'Edit Item',
        confirmMessage: 'Would you like to update the item information?',
        success: 'Item information has been updated.'
      },
      delete: {
        title: 'Delete Item',
        confirmMessage: 'Are you sure you want to delete {{name}}?'
      },
      validation: {
        required: 'Please fill in all required fields.',
        duplicateItem: 'Item already exists.',
        invalidJson: 'Invalid JSON format.'
      },
      searchPlaceholder: 'Search by SKU, name, category, type, spec, UOM, HS code'
    }
  }
  ,
  payment: {
    actions: {
      inputPayment: 'Input Payment',
      printStatus: 'Invoice Status Print',
      excelDownload: 'Status Excel Download'
    },
    messages: {
      selectCompanyFirst: 'Please select a company first',
      selectItems: 'Please select companies'
    },
    excel: {
      vendor: 'Vendor',
      month: 'Month',
      arAmount: 'A/R Amount\n(Invoice)',
      augustInvoice: 'August Invoice',
      invoiceAge: 'Invoice Age\n(Count)',
      resultNote: 'Result Note',
      total: 'Total'
    },
    fields: {
      searchConditions: 'Search Conditions'
    },
    paymentInput: {
      vendorInfoTitle: 'Vendor Info',
      vendorName: 'Vendor Name',
      unpaidAmount: 'Accounts Receivable (Invoice)',
      unpaidInvoiceTitle: 'Unpaid Invoice List',
      inputSectionTitle: 'Payment Input',
      paymentListTitle: 'Payment List',
      submit: 'Submit',
      columns: {
        select: 'Select',
        actions: 'Actions'
      },
      fields: {
        date: 'Date',
        amount: 'Amount',
        paymentMethod: 'Payment Method',
        remark: 'Remark'
      },
      methodOptions: {
        bankTransfer: 'Bank Transfer',
        cash: 'Cash',
        creditCard: 'Credit Card'
      },
      messages: {
        selectInvoices: 'Please select invoices to pay.',
        amountExceedsSelected: 'Entered amount ({{amount}}) exceeds the sum of selected invoices balances ({{sum}}).',
        deleteConfirm: 'Are you sure you want to delete this payment?',
        deleteSuccess: 'Payment deleted successfully.',
        deleteFailed: 'Failed to delete the payment.'
      }
    },
    accountsReceivable: {
      excel: {
        title: 'Invoice Status {{year}}-{{month}}',
        currencyTransaction: '{{currency}} Bank Transaction',
        createdDate: 'Created: {{date}}',
        createdDateLabel: 'Created:',
        vendorName: 'Vendor Name',
        month: 'Month',
        accountsReceivable: 'Accounts Receivable',
        prevMonthInvoice: '{{month}} Invoice',
        amount: 'Amount',
        qty: 'Qty',
        paymentStatus: 'Payment Status',
        remark: 'REMARK',
        monthFormat: '{{month}}',
        yearMonthFormat: '{{year}}-{{month}}',
        subtotal: 'Subtotal',
        grandTotal: 'Grand Total',
        summaryTitle: '{{year}}-{{month}} Summary',
        summaryTitleWithDate: '{{year}}-{{month}}-{{day}} Summary',
        exchangeRate: 'Exchange Rate:',
        exchangeRateLabel: 'Exchange Rate',
        category: 'Category',
        currency: 'Currency',
        originalAmount: 'Original Amount',
        convertedUSD: 'Converted USD',
        convertedIDR: 'Converted IDR',
        convertedKRW: 'Converted KRW',
        prevMonthSales: '{{month}} Sales',
        summarySheet: 'Summary',
        summary: 'Summary',
        filename: '{{year}}-{{month}} Summary',
        filenameWithDate: '{{year}}-{{month}}-{{day}} Summary'
      }
    },
    companyDetail: {
      totalAr: 'Total AR',
      totalReceived: 'Total Received',
      balance: 'Balance',
      invoiceListTitle: 'Invoice List',
      paymentListTitle: 'Payment List',
      columns: {
        invoiceNo: 'Invoice NO',
        amount: 'Amount',
        receivedAmount: 'Received Amount',
        balance: 'Balance',
        dueDate: 'Due Date',
        status: 'Status',
        paymentDate: 'Payment Date',
        currency: 'Currency',
        paymentMethod: 'Payment Method',
        remark: 'Remark',
        createdBy: 'Created By'
      }
    },
    print: {
      dialogTitle: 'Invoice Status',
      title: 'Invoice Status',
      dateOption: 'Date Option',
      currentDate: 'Current Date',
      searchDate: 'Search Date',
      customDate: 'Custom Date',
      selectDate: 'Select Date',
      dateDescription: 'Select the date for invoice status to print',
      printDate: 'Print Date',
      companies: 'companies',
      allCurrencies: 'ALL',
      yearSelect: 'Select Year',
      year: '',
      selectedYear: 'Selected Year',
      currentYear: 'Current Year',
      selectDateDescription: 'Select the reference date for invoice status to print',
      dateSelection: 'Date Selection Options',
      selectCustom: 'Select custom date',
      selectedDate: 'Selected Date',
      preview: 'Preview',
      generatedBy: 'Generated by SAMJIN ERP System',
      monthInvoice: ' Month Invoice',
      qty: 'QTY',
      summary: 'Summary',
      currency: 'Currency',
      totalAmount: 'Total Amount',
      headers: {
        company: 'Company',
        vendor: 'Vendor',
        monthly: 'Monthly',
        invoice: 'Invoice',
        invoiceNo: 'Number',
        qty: 'Quantity',
        amount: 'Amount',
        receivedAmount: 'Paid Amount',
        unpaid: 'Unpaid',
        currentMonthInvoice: '{{month}}-Month Invoice',
        currentMonthInvoiceQty: 'Invoice QTY',
        remark: 'Remark'
      },
      totalByCompany: 'Subtotal',
      grandTotal: 'Grand Total',
      paidComplete: 'Paid Complete',
      noDataAvailable: 'No data available',
      noDataDescription: 'There is no invoice data matching your selected criteria.',
      collectionRate: 'Collection Rate',
      monthlyTrend: 'Monthly Unpaid Trend',
      currencyDistribution: 'Currency Distribution',
      monthlyUnpaidDetail: 'Monthly Unpaid by Company',
      invoiceStatusReport: 'Invoice Status Report',
      currencySection: 'Section',
      vendorNamePlaceholder: 'Vendor Name',
      vendorSearch: 'Search vendor...',
      companyCount: '{{count}} companies',
      monthlyTotal: ' Total',
      yearCurrencyStatus: '{{year}} {{currency}} Status',
      grandTotal: 'Grand Total',
      summary: 'Summary',
      currencySummary: 'Currency Summary',
      monthlyTrend: 'Monthly Trend',
      monthSuffix: '',
      totalUnpaid: 'Total Unpaid',
      reportDate: 'Report Date',
      executiveSummary: 'Executive Summary',
      totalInvoices: 'Total Invoices',
      totalAmountKRW: 'Total Amount (KRW)',
      avgCollectionRate: 'Avg Collection Rate',
      currencyBreakdown: 'Currency Breakdown',
      status: 'Status',
      excellent: 'Excellent',
      good: 'Good',
      needImprovement: 'Needs Improvement',
      monthlyPerformance: 'Monthly Performance',
      paidAmount: 'Paid Amount',
      trend: 'Trend',
      invoiceCount: 'Invoice Count',
      yearSuffix: '',
      currencyStatus: 'Status',
      filter: {
        all: 'All',
        paid: 'Paid',
        unpaid: 'Unpaid'
      },
      headers: {
        currency: 'Currency',
        invoiceCount: 'Invoice Count',
        totalAmount: 'Total Amount',
        paidAmount: 'Paid Amount',
        unpaidAmount: 'Unpaid Amount',
        collectionRate: 'Collection Rate',
        vendorName: 'Vendor',
        month: 'Month',
        monthSuffix: '',
        invoice: 'Invoice',
        invoiceNo: 'Invoice NO.',
        qty: 'Quantity',
        arAmount: 'Invoice Amount',
        receivedAmount: 'Payment Amount',
        remark: 'Remark',
        date: 'Date',
        status: 'Status'
      },
      paid: 'Paid',
      unpaid: 'Unpaid'
    },
    columns: {
      companyName: 'Company',
      arAmount: 'Accounts Receivable (Invoice)',
      qty: 'Invoice Quantity (Qty)',
      oldestDate: 'Payment Due Date'
    }
  },

  windingDataPopup: {
    title: 'Shipping Management',
    basicInfo: 'Basic Information',
    shippingInfo: 'Shipping Information',
    remarksAndNotes: 'Remarks and Notes',
    windingId: 'Winding ID',
    shippingTargetDate: 'Shipping Target Date',
    truckName: 'Truck Name',
    numberOfBox: 'Number of Boxes',
    timeOfDeparture: 'Time of Departure',
    timeOfArrival: 'Time of Arrival',
    remarkForShipping: 'Shipping Remark',
    remark: 'General Remark',
    factory: 'Factory',
    loading: 'Loading data...',
    error: 'An error occurred',
    retry: 'Retry',
    close: 'Close',
    refresh: 'Refresh',
    noData: 'No data',
    networkError: 'A network error occurred. Please check your internet connection.',
    serverError: 'A server error occurred. Please try again later.',
    notFound: 'Data for Winding ID {{id}} not found.',
    timeoutError: 'Request timed out. Please check your network status.',
    fetchFailed: 'Failed to load data.',
    apiError: 'An error occurred during API request. ({{status}})',
    unknownError: 'An unknown error occurred.',
    arrived: 'Arrived',
    depart: 'Depart',
    completed: 'Completed',
    updating: 'Updating...',
    updateFailed: 'Update failed.'
  },

  map: {
    controls: {
      title: 'Factory Map',
      searchPlaceholder: 'Search by factory name, region, address...',
      factories: 'Factory List',
      selectedFactory: 'Selected Factory',
      region: 'Region',
      address: 'Address',
      shippingMark: 'Shipping Mark',
      selected: 'Selected',
      noSearchResults: 'No search results found.',
      noFactories: 'No factories available.',
      zoomIn: 'Zoom In',
      zoomOut: 'Zoom Out',
      resetView: 'Reset View'
    },
    error: {
      fetchFailed: 'Failed to load factory data.',
      apiLoadFailed: 'Failed to load Google Maps API.',
      apiKeyRequired: 'Google Maps API key is required. Please set REACT_APP_GOOGLE_MAPS_API_KEY environment variable.'
    }
  },
  inventory: {
    balance: {
      columns: {
        category: 'Category',
        type: 'Type',
        sku: 'SKU',
        name: 'Item',
        location: 'Location',
        qty: 'Quantity',
        uom: 'UOM',
        note: 'Note',
        report: 'Report'
      },
      report: {
        title: 'Inventory Trend Report',
        graphButton: 'Graph',
        period: 'Period: {{start}} ~ {{end}}',
        itemIdLabel: 'Item ID: {{id}}',
        locationLabel: 'Location: {{location}}',
        startDateLabel: 'Start Date',
        endDateLabel: 'End Date',
        applyRange: 'Apply Range',
        dailyChartTitle: 'Daily Quantity Change',
        cumulativeChartTitle: 'Cumulative Quantity',
        combinedChartTitle: 'Daily Change & Cumulative Trend',
        dailyChartLegend: 'Qty Change',
        cumulativeChartLegend: 'Cumulative Qty',
        noData: 'No movement recorded for this period.',
        fetchError: 'Failed to load graph data.',
        invalidRange: 'Start date cannot be later than end date.',
        locationRequired: 'Location information is required to view the graph.'
      }
    },
    adjustment: {
      title: 'Inventory Movement',
      form: {
        title: 'Register Movement'
      },
      list: {
        title: 'Inventory Movement Records',
        createdAt: 'Created At',
        txTime: 'Movement Time',
        txType: 'Inventory Movement Type',
        txSubtype: 'Subtype',
        item: 'Item',
        qty: 'Quantity',
        uom: 'UOM',
        fromLocation: 'From Location',
        toLocation: 'To Location',
        inventoryStatus: 'Inventory Status',
        currency: 'Currency',
        note: 'Note',
        searchPlaceholder: 'Search by item, type, status, note...',
        selectItem: 'Select an item',
        searchHint: 'An item must be selected. The search period cannot exceed 1 year.',
        createdAtRange: 'System input time',
        txTimeStart: 'Movement start time',
        txTimeEnd: 'Movement end time'
      },
      fields: {
        txTime: 'Inventory Movement Time',
        txType: 'Inventory Movement Type',
        docType: 'Document Type',
        docId: 'Document ID',
        item: 'Item',
        lotId: 'LOT',
        fromLocation: 'From Location',
        toLocation: 'To Location',
        qty: 'Quantity',
        uom: 'UOM',
        unitCost: 'Unit Cost',
        currency: 'Currency',
        inventoryStatus: 'Inventory Status',
        note: 'Note',
        noLocation: 'None'
      },
      txTypes: {
        receipt: 'Receipt',
        issue: 'Issue',
        transfer: 'Transfer',
        adjustment: 'Adjustment',
        productionConsume: 'Production Consume',
        productionOutput: 'Production Output'
      },
      txSubtypes: {
        normal: 'Normal',
        void: 'Void',
        reversal: 'Reversal'
      },
      inventoryStatus: {
        available: 'Available',
        reserved: 'Reserved',
        wip: 'WIP',
        qcHold: 'QC Hold',
        damaged: 'Damaged'
      },
      add: {
        title: 'Register Movement',
        confirmMessage: 'Would you like to register this movement?',
        success: 'Movement has been registered.'
      },
      edit: {
        title: 'Edit Movement',
        confirmMessage: 'Would you like to update this movement?',
        success: 'Movement has been updated.'
      },
      validation: {
        required: 'Please fill in the required fields.',
        invalidNumber: 'Please enter a valid number.',
        bothLocationsRequired: 'Please enter at least one of From Location or To Location.',
        itemRequired: 'Please select an item.',
        dateRange: 'Start date must be on or before end date.',
        maxDateRange: 'The search period cannot exceed 365 days.'
      },
      delete: {
        title: 'Inventory Movement Reversal Processing',
        confirmMessage: 'Would you like to process reversal for this inventory movement?',
        success: 'Reversal processing has been completed.',
        receiptIssueWarning: 'Deletion is available in the Receipt/Issue Registration page.'
      }
    },
    batchInput: {
      saveConfirm: {
        title: 'Save Confirmation',
        changedItems: 'Changed Items',
        txTimeField: 'Inventory movement time',
        txTimeLabel: 'Current inventory movement time: {{time}}',
        negativeValueError: 'Negative values cannot be entered for today receipt or today issue. Please process reversal for incorrectly entered quantities in the inventory transaction history page.'
      },
      title: 'Batch Input',
      snapshotPending: 'Month-end snapshot is not ready yet.',
      date: 'Date',
      location: 'Location',
      columns: {
        sku: 'SKU',
        name: 'Item Name',
        previousBalance: 'Previous Balance',
        todayReceipt: 'Today Receipt',
        todayIssue: 'Today Issue',
        todayBalance: 'Today Balance',
        uom: 'UOM'
      },
      saveSuccess: 'Data saved successfully.',
      saveFailed: 'Failed to save data.',
      noChanges: 'No Changes',
      noChangesMessage: 'No changes to save.',
      toggleUomTooltip: 'Toggle between base UOM and secondary UOM',
      baseUom: 'Base UOM',
      secondaryUom: 'Secondary UOM',
      selectDateAndCategory: 'Please select date and category.',
      bulkJob: {
        title: 'Bulk inventory processing',
        jobId: 'Job ID',
        status: 'Status',
        pollingHint: 'Processing asynchronously on the server. Please wait until it completes.',
        lineIndex: 'Line',
        error: 'Error',
        timeout: 'The wait time exceeded. Please verify results in inventory transactions.',
        statusFailed: 'Could not retrieve job status.',
        submitFailed: 'Could not submit the bulk job.',
        noJobId: 'The server response did not include a job ID.',
        partialSuccess: 'Some lines failed ({{count}}). Please review the list.',
        jobFailed: 'The bulk job failed.',
        chunkSummary: 'Chunks: {{completed}} / {{total}} done',
        lineSummary: 'Lines: success {{success}} · failed {{failure}} · total {{total}}'
      }
    },
    lotBatch: {
      sharedBox: 'Same box',
      tabs: {
        incoming: 'Incoming LOT Registration',
        outgoing: 'Outgoing LOT Registration',
        batch: 'Outgoing LOT Batch Creation',
        batchComingSoon: 'Outgoing batch registration feature will be developed in the next phase.'
      },
      vehicleAssignment: {
        title: 'Vehicle Assignment',
        adjustButton: 'Vehicle Assignment',
        workOrder: 'Outgoing Request List',
        changeDate: 'Change Date',
        batchChange: 'Batch Date Change',
        saveFailed: 'Save Failed',
        saveFailedMessage: 'An error occurred while saving vehicle assignment.',
        saveSuccess: 'Save Complete',
        saveSuccessMessage: 'Vehicle assignment has been saved successfully.',
        truckList: 'TRUCK List',
        noTrucks: 'No trucks registered.',
        time: 'Time',
        addDate: 'Add Date',
        noLotForDate: 'No LOT to deliver on this date.',
        itemCount: '{{count}} item',
        itemCount_plural: '{{count}} items',
        dropToAssign: 'Drop here to assign vehicle',
        dateTimeFormat: 'MMMM DD, YYYY HH:mm',
        dateFormat: 'MMMM DD, YYYY',
        days: {
          sun: 'Sun',
          mon: 'Mon',
          tue: 'Tue',
          wed: 'Wed',
          thu: 'Thu',
          fri: 'Fri',
          sat: 'Sat'
        }
      },
      giLot: {
        batch: {
          create: 'Create Outgoing LOT',
          edit: 'Edit Outgoing LOT',
          update: 'Update',
          editDescription: 'Editing {{count}} selected outgoing LOT(s). You can drag rows to change the order.',
          createDescription: 'Creating outgoing LOT(s) for {{count}} selected request(s). You can drag rows to change the order.',
          labels: {
            requestId: 'Request ID',
            delivery: 'Delivery',
            customer: 'Customer',
            manager: 'Contact'
          },
          hasLotNo: 'Selected items already have LOT NO.',
          lotNoToggleOn: 'All',
          lotNoToggleOff: 'Unassigned',
          lotNoToggleHint:
            'Off: show only rows without LOT NO. On: include rows that already have LOT NO.',
          tableColumns: {
            reqId: 'REQ ID',
            reqDate: 'REQ DATE',
            delivery: 'DELIVERY',
            customer: 'CUSTOMER',
            manager: 'CONTACT',
            qty: 'QTY',
            detail: 'DETAIL',
            box: 'BOX',
            lotNo: 'LOT NO',
            estTime: 'EST. TIME',
            slot: 'SLOT',
            truck: 'TRUCK',
            misc: 'MISC'
          },
          missingAttributes: {
            title: 'Missing Attributes',
            message: 'The following items are missing required attributes to calculate box and weight:'
          },
          createSuccess: {
            title: 'Creation Complete',
            message: 'Outgoing LOTs have been created successfully.'
          },
          createError: {
            title: 'Creation Error',
            message: 'Some outgoing LOTs failed to create:',
            general: 'An error occurred while creating outgoing LOTs.'
          },
          updateSuccess: {
            title: 'Update Complete',
            message: 'Outgoing LOTs have been updated successfully.'
          },
          updateError: {
            title: 'Update Error',
            message: 'Some outgoing LOTs failed to update:',
            general: 'An error occurred while updating outgoing LOTs.'
          },
          editError: {
            title: 'Fetch Error',
            message: 'Unable to fetch outgoing LOT data.',
            general: 'An error occurred while fetching outgoing LOT data.'
          },
          deleteConfirm: {
            title: 'Delete Confirmation',
            message: 'Are you sure you want to delete this outgoing LOT?'
          },
          deleteSuccess: {
            title: 'Delete Complete',
            message: 'Outgoing LOT has been deleted successfully.'
          },
          deleteError: {
            title: 'Delete Error',
            message: 'Unable to find outgoing LOT ID.',
            general: 'An error occurred while deleting outgoing LOT.'
          }
        },
        fields: {
          lotNo: 'LOT No',
          expectedGiAt: 'Expected Outgoing Time',
          workShift: 'Work Deadline Time Slot',
          workShiftOptions: {
            none: 'Not Selected',
            shift_00_03: '00:00 - 03:00',
            shift_03_06: '03:00 - 06:00',
            shift_06_09: '06:00 - 09:00',
            shift_09_12: '09:00 - 12:00',
            shift_12_15: '12:00 - 15:00',
            shift_15_18: '15:00 - 18:00',
            shift_18_21: '18:00 - 21:00',
            shift_21_24: '21:00 - 24:00'
          },
          docType: 'Document Type',
          docId: 'Document ID',
          deliveryId: 'Delivery ID',
          deliveryName: 'Delivery Name',
          addressSection: 'Delivery Information',
          address1: 'Address 1',
          address2: 'Address 2',
          city: 'City',
          state: 'State/Province',
          postcode: 'Postcode',
          country: 'Country',
          lines: 'Outgoing Line',
          detail: 'Detail',
          attributes: 'Attributes',
          truck: 'Truck'
        }
      },
      fields: {
        item: 'Item',
        lotNo: 'LOT No',
        lotNoMode: 'LOT No Option',
        supplierLotNo: 'Supplier LOT No',
        mfgDate: 'Manufacturing Date',
        expiryDate: 'Expiry Date',
        qcStatus: 'QC Status',
        lotNoPrefix: 'LOT No Prefix',
        category: 'Category',
        attributes: 'Attributes',
        createdAt: 'LOT Created At'
      },
      qcStatus: {
        available: 'Available',
        reserved: 'Reserved',
        wip: 'WIP',
        qcHold: 'QC Hold',
        damaged: 'Damaged'
      },
      list: {
        title: 'LOT List'
      },
      form: {
        title: 'Register LOT',
        lotMode: {
          auto: 'Auto-generate',
          manual: 'Use existing LOT'
        },
        lotNoAutoHint: 'Enter a prefix to create LOT numbers automatically.',
        lotNoManualHint: 'Enter a previously issued LOT number.'
      },
      add: {
        title: 'Register LOT',
        confirmMessage: 'Would you like to register this LOT?',
        success: 'LOT has been registered.'
      },
      edit: {
        title: 'Edit LOT',
        confirmMessage: 'Would you like to update this LOT?',
        success: 'LOT has been updated.'
      },
      validation: {
        required: 'Please fill in the required fields.',
        itemRequired: 'Please select an item.',
        qcStatusRequired: 'Please select QC status.',
        lotNoRequired: 'Please enter the LOT number.'
      },
      searchPlaceholder: 'Search by LOT No, Item ID, Supplier LOT No...'
    },
    giLot: {
      fields: {
        lotNo: 'LOT No',
        expectedGiAt: 'Expected Outgoing Time',
        workShift: 'Work Deadline Time Slot',
        workShiftOptions: {
          none: 'Not Selected',
          shift_00_03: '00:00 - 03:00',
          shift_03_06: '03:00 - 06:00',
          shift_06_09: '06:00 - 09:00',
          shift_09_12: '09:00 - 12:00',
          shift_12_15: '12:00 - 15:00',
          shift_15_18: '15:00 - 18:00',
          shift_18_21: '18:00 - 21:00',
          shift_21_24: '21:00 - 24:00'
        },
        docType: 'Document Type',
        docId: 'Document ID',
        deliveryId: 'Delivery ID',
        deliveryName: 'Delivery Name',
        addressSection: 'Delivery Information',
        address1: 'Address 1',
        address2: 'Address 2',
        city: 'City',
        state: 'State/Province',
        postcode: 'Postcode',
        country: 'Country',
        lines: 'Outgoing Line',
        detail: 'Detail',
        attributes: 'Attributes',
        truck: 'Truck'
      },
      lines: {
        lineLabel: 'GI Line {{index}}',
        item: 'Item',
        itemId: 'Item ID',
        qty: 'Quantity',
        qtyBox: 'BOX Quantity',
        mfgDate: 'Manufacturing Date',
        expiryDate: 'Expiry Date',
        qcStatus: 'QC Status',
        subOrderId: 'Sub Order ID'
      },
      docType: {
        gir: 'Outgoing Request',
        etc: 'ETC'
      },
      form: {
        title: 'Outgoing LOT Registration'
      },
      add: {
        title: 'Outgoing LOT Registration',
        confirmMessage: 'Would you like to register this outgoing LOT?',
        success: 'Outgoing LOT has been registered.'
      },
      edit: {
        title: 'Outgoing LOT Edit',
        confirmMessage: 'Would you like to update this outgoing LOT?',
        success: 'Outgoing LOT has been updated.'
      },
      delete: {
        title: 'Delete Confirmation',
        confirmMessage: 'Are you sure you want to delete this data?'
      },
      list: {
        title: 'Outgoing LOT List'
      },
      validation: {
        linesRequired: 'Item and quantity are required for outgoing lines.'
      },
      deliveryDialog: {
        title: 'Search Delivery',
        searchPlaceholder: 'Search by Delivery ID, Name, Address...'
      },
      searchPlaceholder: 'Search by LOT number, Document ID, etc...'
    },
    grLot: {
      fields: {
        supplier: 'Supplier',
        grDate: 'Expected GR Date',
        docType: 'Document Type',
        docId: 'Document ID',
        lines: 'Incoming Line',
        attributes: 'Attributes'
      },
      lines: {
        lineLabel: 'GR Line {{index}}',
        item: 'Item',
        uom: 'Unit',
        qty: 'Quantity',
        qtyBox: 'BOX Quantity',
        supplierLotNo: 'Supplier LOT No',
        mfgDate: 'Manufacturing Date',
        expiryDate: 'Expiry Date',
        qcStatus: 'QC Status'
      },
      docType: {
        po: 'Purchase Order',
        etc: 'ETC'
      },
      validation: {
        linesRequired: 'Item and quantity are required for incoming lines.'
      }
    }
  },
  scm: {
    goodsReceipt: {
      list: {
        title: 'Goods Receipt List',
        grDate: 'GR Date',
        supplier: 'Supplier',
        poId: 'PO ID',
        lines: 'Details',
        note: 'Note',
        createdAt: 'Created At',
        searchPlaceholder: 'Search by GR ID, Supplier, PO ID, etc.'
      },
      form: {
        title: 'Goods Receipt Registration',
        lines: 'Details',
        lineNo: 'Detail {{no}}'
      },
      fields: {
        lotNo: 'LOT No',
        supplier: 'Supplier',
        grDate: 'GR Date',
        poId: 'PO ID',
        note: 'Note',
        customDocDate: 'Customs Registration Date',
        customDocType: 'Customs Document Type',
        customDocNo: 'Customs Document No',
        customsSection: 'Customs Information',
        item: 'Item',
        lot: 'LOT',
        qty: 'Quantity',
        uom: 'UOM',
        toLocation: 'To Location',
        unitPrice: 'Unit Price',
        currency: 'Currency',
        totalAmount: 'Total Amount'
      },
      add: {
        title: 'Register Goods Receipt',
        confirmMessage: 'Would you like to register a new goods receipt?',
        success: 'Goods receipt has been registered.'
      },
      edit: {
        title: 'Edit Goods Receipt',
        confirmMessage: 'Would you like to update this goods receipt?',
        success: 'Goods receipt has been updated.'
      },
      delete: {
        title: 'Cancel Goods Receipt',
        confirmMessage: 'Would you like to cancel this goods receipt?'
      },
      validation: {
        required: 'Please fill in the required fields.',
        atLeastOneLine: 'At least one line is required.',
        lineRequired: 'Please fill in the required fields for the line.'
      },
      lotDialog: {
        title: 'Select GR LOT',
        searchPlaceholder: 'Search by LOT No, Item ID, etc...'
      }
    },
    goodsIssue: {
      list: {
        title: 'Goods Issue Registration List',
        giTime: 'GI Time',
        toDelivery: 'To Delivery',
        giPostNo: 'GI Document No',
        outboundLotNo: 'Outbound LOT No',
        customsDocNo: 'Customs Document No',
        lines: 'Details',
        remarks: 'Remarks',
        createdAt: 'Created At',
        searchPlaceholder: 'Search by GI ID, Delivery, Document No, etc.'
      },
      form: {
        title: 'Goods Issue Registration',
        lines: 'Details',
        lineNo: 'Detail {{no}}'
      },
      fields: {
        toDelivery: 'To Delivery',
        giTime: 'GI Time',
        giPostNo: 'GI Document No',
        outboundLotNo: 'Outbound LOT No',
        customsDocNo: 'Customs Document No',
        customsReceiptNo: 'Customs Receipt No',
        remarks: 'Remarks',
        item: 'Item',
        lot: 'LOT',
        qty: 'Quantity',
        uom: 'UOM',
        fromLocation: 'From Location',
        subOrderId: 'Sub Order ID',
        selectedFiles: 'Selected Files'
      },
      add: {
        title: 'Register Goods Issue',
        confirmMessage: 'Would you like to register a new goods issue?',
        success: 'Goods issue has been registered.'
      },
      edit: {
        title: 'Edit Goods Issue',
        confirmMessage: 'Would you like to update this goods issue?',
        success: 'Goods issue has been updated.'
      },
      delete: {
        title: 'Delete Goods Issue',
        confirmMessage: 'Would you like to delete goods issue "{{name}}"?'
      },
      validation: {
        required: 'Please fill in the required fields.',
        atLeastOneLine: 'At least one line is required.',
        lineRequired: 'Please fill in the required fields for the line.'
      },
      tabs: {
        general: 'General Goods Issue Registration',
        batch: 'Batch Goods Issue Registration'
      },
      batch: {
        create: 'Batch Goods Issue Registration',
        edit: 'Edit Batch Goods Issue',
        createDialog: {
          title: 'Batch Goods Issue Registration'
        },
        editDialog: {
          title: 'Edit Batch Goods Issue'
        },
        submitting: 'Registering goods issue...',
        deleteAll: 'Delete All',
        details: 'Details',
        shipCustomsInfo: 'Shipping · Customs',
        confirmDelete: 'Delete this goods issue?',
        confirmDeleteAll: 'Delete all selected goods issues?',
        validation: {
          customsDocNoRequired: 'Customs document number is required.',
          fieldRequired: 'This field is required.'
        },
        createError: 'An error occurred while registering goods issue.',
        createFailed: 'Failed to create GI post for lot {{lotNo}}: {{errorMessage}}',
        truckColumn: 'TRUCK',
        completed: 'Completed',
        completedToggleOn: 'All',
        completedToggleOff: 'Pending',
        completedToggleHint:
          'Completed filter: Pending shows only rows without a GI POST ID; All includes posted (completed) rows.',
        columns: {
          lotNo: 'LOT NO',
          estTime: 'Est. time',
          delivery: 'Delivery',
          truck: 'Truck',
          detail: 'Detail',
          customDate: 'Custom date',
          customType: 'Custom type',
          customNo: 'Custom no.',
          noExBC: 'No ExBC',
          giPostId: 'GI POST ID',
          giPostNo: 'GI POST NO',
          postAt: 'Posted at',
          updatedAt: 'Updated at'
        }
      },
      lotDetail: {
        title: 'GI LOT Detail',
        basicInfo: 'Basic Information',
        lotLines: 'GI LOT Lines',
        shippingRequest: 'Shipping Request Information',
        giRequest: 'GI Request Information',
        orders: 'Order Information',
        consumption: 'Consumption Information',
        production: 'Production Information',
        giPost: 'GI Post Information',
        fields: {
          lotNo: 'LOT NO',
          expectedGiAt: 'Expected GI Time',
          workShift: 'Work Shift',
          docType: 'Document Type',
          docId: 'Document ID',
          delivery: 'Delivery',
          address1: 'Address 1',
          address2: 'Address 2',
          cityState: 'City, State',
          postcode: 'Postcode',
          attributes: 'Attributes',
          lineNo: 'Line No',
          itemId: 'Item ID',
          itemName: 'Item Name',
          qty: 'Qty',
          qtyBox: 'Qty Box',
          subOrderId: 'Sub Order ID',
          qcStatus: 'QC Status',
          mfgDate: 'Mfg Date',
          expiryDate: 'Expiry Date',
          giRequestId: 'GI Request ID',
          lines: 'Lines',
          orderId: 'Order ID',
          buyer: 'Buyer',
          vendor: 'Vendor',
          manager: 'Manager',
          deliveryField: 'Delivery',
          subOrders: 'Sub Orders',
          color: 'Color',
          price: 'Price',
          currency: 'Currency',
          uom: 'UOM',
          weight: 'Weight(kg)',
          location: 'Location',
          sourceTxName: 'Source TX Name',
          workType: 'Work Type',
          workId: 'Work ID',
          giPostId: 'GI Post ID',
          giPostNo: 'GI Post No',
          giLotNo: 'GI-LOT-NO',
          giTime: 'GI Time',
          customsReceiptNo: 'Receipt No',
          customDocType: 'Custom Doc Type',
          registrationNo: 'Registration No',
          noDocExbc: 'No Doc ExBC',
          customDocDate: 'Custom Doc Date',
          remarks: 'Remarks',
          uomId: 'UOM ID',
          fromLocationId: 'From Location ID',
          lotId: 'Lot ID',
          unitPrice: 'Unit Price',
          grossWeight: 'Gross Weight'
        }
      }
    },
    deliveryInfo: {
      downloadAttachment: 'Download attachment',
      sections: {
        search: '1. Search Goods Issue',
        completion: '2. Delivery Completion',
        completionEdit: '2. Edit Delivery Completion'
      },
      search: {
        hint: 'Enter at least {{min}} characters of the customs registration number to search.',
        optionalHint:
          'Optional. Load from goods issue search or enter details below manually. (Search requires {{min}}+ characters)',
        placeholder: 'Partial customs number',
        minLength: 'Customs number must be at least {{min}} characters.',
        noResults: 'No results found.',
        failed: 'Failed to search goods issue records.',
        action: 'Action',
        registered: 'Registered'
      },
      load: {
        failed: 'Failed to load goods issue detail.',
        noLines: 'No goods issue lines found.'
      },
      fields: {
        customsRegistrationNo: 'Customs Registration No',
        deliveryStatus: 'Delivery Status',
        deliveryCompletedAt: 'Delivery Completed Date',
        suratJalanFiles: 'Delivery Note Scan Files'
      },
      giContext: {
        label: 'Loaded goods issue'
      },
      lines: {
        add: 'Add line',
        itemPlaceholder: 'Search item'
      },
      status: {
        pending: 'Pending',
        confirmed: 'Confirmed',
        rejected: 'Rejected',
        cancelled: 'Cancelled'
      },
      files: {
        select: 'Select Files',
        hint: 'Upload PDF or image files.',
        existing: 'Registered delivery notes'
      },
      submit: {
        button: 'Register Delivery Completion',
        updateButton: 'Update Delivery Completion',
        submitting: 'Submitting...',
        updating: 'Updating...',
        success: 'Delivery completion has been registered.',
        updateSuccess: 'Delivery completion has been updated.',
        failed: 'Failed to register delivery completion.',
        noGiPost: 'Please select a goods issue record first.',
        noLines: 'Enter at least one valid line (item, quantity, UOM).',
        noCustomsNo: 'Customs registration number is missing.',
        noCompletionDate: 'Please select the delivery completion date.',
        filesRequired: 'Please attach at least one delivery note scan file.'
      },
      email: {
        dialogTitle: 'Send Email',
        dialogSubtitle:
          'Would you like to send an email to the person in charge? Review the details below and click Send.',
        contentLanguage: 'Email content language',
        lang: {
          ko: '한국어',
          en: 'English',
          id: 'Bahasa Indonesia'
        },
        defaultSubject: 'DELIVERY NOTE {{destination}} {{date}}',
        from: 'From',
        fromSystemFixed: 'System sender (server configured)',
        to: 'To',
        cc: 'CC',
        subject: 'Subject',
        body: 'Body',
        bodyHelper: 'The text below will be sent as the email body. You can edit it if needed.',
        bodyIntro: 'Hello, please find the delivery completion notice below.',
        suratJalanNo: 'Delivery note no.',
        deliveryCompletedAt: 'Delivery completed date',
        deliveryDestination: 'Destination',
        linesHeader: '[Quantities by item]',
        styleNo: 'Style No',
        item: 'Item',
        color: 'Color',
        qty: 'Qty',
        noReplyNotice: '※ This email was sent automatically by the system and cannot receive replies. For any inquiries, please contact the person in charge.',
        loadingOrderMeta: 'Loading order details...',
        emailListHint: 'Separate multiple addresses with comma, semicolon, or new line',
        attachmentsTitle: 'Attachments',
        attachmentsFixedHint:
          'All delivery note files uploaded at registration are attached (cannot be changed).',
        attachmentSizeLimit:
          'Attachment limits: total max {{total}}, per file max {{perFile}}. Sending is blocked if exceeded.',
        noAttachments: 'No attachments.',
        sendButton: 'Send email',
        sending: 'Sending email...',
        sendSuccess: 'Email has been sent.',
        sendFailed: 'Failed to send email.',
        toRequired: 'Enter at least one recipient email.',
        invalidEmails: 'Invalid {{field}} address: {{emails}}',
        attachmentSizeExceeded:
          'Attachment size exceeds the limit. Reduce files and try again.'
      },
      errors: {
        createFailed: 'Failed to register delivery completion.',
        fetchFailed: 'Failed to load delivery completion.',
        updateFailed: 'Failed to update delivery completion.'
      }
    },
    deliveryStatus: {
      filter: {
        title: 'Search Conditions'
      },
      columns: {
        deliveryStatus: 'Delivery Status',
        suratJalan: 'Delivery Note'
      },
      status: {
        notRegistered: 'Not Registered'
      },
      table: {
        count: '{{count}} / {{total}} records',
        searchHint: 'Select a date range and search.',
        endOfList: 'End of list.'
      },
      validation: {
        dateRequired: 'Please enter start and end dates.',
        dateRange: 'Start date must be on or before end date.'
      },
      errors: {
        fetchFailed: 'Failed to load delivery status.'
      }
    }
  },
  warning: {
    title: 'Warning'
  }
};